export type LandingLocale = 'en' | 'zh-CN' | 'zh-TW'

export type LandingMessages = Record<string, string | string[]>

export const landingMessages: Record<LandingLocale, LandingMessages> = {
  en: {
    'nav.search': 'Search',
    'nav.home': 'Home',
    'nav.official': 'Official Skills',
    'nav.community': 'Global Skills',
    'nav.login': 'Login',
    'nav.browseSkills': 'Browse Skills',
    'nav.signUp': 'Sign up for free',
    'nav.logout': 'Log out',
    'nav.accountMenu': 'Account',
    'nav.apiKey': 'API Key',
    'apiKey.title': 'API Key',
    'apiKey.desc': 'Use this key to authenticate SkillHub API requests.',
    'apiKey.loginHint': 'Log in to view and copy your API Key.',
    'apiKey.masked': 'fsk_********',
    'apiKey.close': 'Close',
    'apiKey.loading': 'Loading…',
    'apiKey.copy': 'Copy',
    'apiKey.copied': 'Copied',
    'apiKey.copyFail': 'Copy failed',
    'apiKey.retry': 'Retry',
    'apiKey.loginToCopy': 'Log in to copy',
    'apiKey.err.needLogin': 'Please log in first',
    'apiKey.err.badUin': 'Session error, please log in again',
    'apiKey.err.verifyFail': 'Identity verification failed, please try again later',
    'apiKey.err.revoked': 'Key disabled, please contact support',
    'apiKey.err.internal': 'Service busy, please try again later',
    'nav.openMenu': 'Open menu',
    'nav.closeMenu': 'Close menu',
    'auth.close': 'Close',
    'auth.title': 'Hello, welcome',
    'auth.desc': 'Sign in with your Fosun Wealth app account for FinTrust Skills Hub',
    'auth.phonePlaceholder': 'Enter mobile number',
    'auth.areaCodeLabel': 'Area code',
    'auth.areaCodePlaceholder': '+852',
    'auth.areaCodeSearchPlaceholder': 'Search region or code',
    'auth.areaCodeLoading': 'Loading…',
    'auth.commonRegions': 'Common regions',
    'auth.noAreaCodeResults': 'No results',
    'auth.codePlaceholder': 'Enter verification code',
    'auth.resendCountdown': 'Resend code in {n} seconds',
    'auth.getCode': 'Get code',
    'auth.agreePrefix': 'I have read and agree to the',
    'auth.userAgreement': 'User Agreement',
    'auth.agreeAnd': 'and',
    'auth.privacy': 'Privacy Policy',
    'auth.login': 'Sign in',
    'auth.submitting': 'Submitting…',
    'auth.autoRegister': 'New users are registered automatically on first sign-in',
    'auth.registerHint': 'Sign in with SMS; new numbers are registered automatically',
    'auth.invalidPhone': 'Enter a valid mobile number',
    'auth.codeSent': 'Verification code sent',
    'auth.sendTooOften': 'Too many requests, try again later',
    'auth.codeSendFailed': 'Failed to send verification code',
    'auth.captchaFailed': 'Verification failed, please try again',
    'auth.networkError': 'Server unavailable, try again later',
    'auth.agreeRequired': 'Please read and agree to the User Agreement and Privacy Policy',
    'auth.phoneRequired': 'Enter mobile number',
    'auth.getCodeFirst': 'Get verification code first',
    'auth.codeRequired': 'Enter verification code',
    'auth.submitSuccess': 'Signed in successfully',
    'auth.invalidCode': 'Invalid or expired code, try again',
    'hero.title': 'Trusted Financial Skills',
    'hero.titleAccent': 'All in One Place',
    'nav.about': 'About us',
    'route.title.landing': 'FinTrust Skills Hub',
    'route.title.official': 'FinTrust Skills Hub – Official Skills',
    'route.title.community': 'FinTrust Skills Hub – Global Skills',
    'route.title.skillHub': 'FinTrust Skills Hub – Skills',
    'route.title.skillDetail': 'FinTrust Skills Hub',
    'route.title.installGuide': 'FinTrust Skills Hub – {hero}',
    'landingOfficialPage.heroTitleMain': 'Official Skills',
    'landingOfficialPage.heroTitleSub': '· Powered by Fosun Wealth',
    'landingOfficialPage.heroDesc':
      'Focused on core finance scenarios, published and maintained by the platform to help agents quickly gain professional, reliable, and continuously updated financial capabilities.',
    'landingOfficialPage.loadFailed': 'Failed to load official Skills',
    'landingCommunityPage.heroTitleMain': 'Global Skills',
    'landingCommunityPage.heroTitleSub': '· Curated safe and stable financial skills',
    'landingCommunityPage.heroDesc':
      'Curated from skill communities for finance scenarios, covering equities, A-shares, DeFi, monitoring, analytics, and more to help agents quickly expand professional capabilities.',
    'landingCommunityPage.loadFailed': 'Failed to load Global Skills',
    'landingSkillList.title': 'Skills',
    'landingSkillList.filterAria': 'Filter by tag',
    'landingSkillList.filterLabel': 'Filter by tag',
    'landingSkillList.reset': 'Reset',
    'landingSkillList.loading': 'Loading...',
    'landingSkillList.empty': 'No more content',
    'landingSkillList.badgeOfficial': 'Official',
    'landingSkillList.badgeCommunity': 'Global',
    'landingSkillList.avatarFallback': 'S',
    'landingSkillList.officialPaginationLabel': 'Official Skills pagination',
    'landingSkillList.communityPaginationLabel': 'Global Skills pagination',
    'landingSkillList.tag.aiHotNews': 'AI hot news',
    'landingSkillList.tag.trading': 'Trading',
    'landingSkillList.tag.globalHotNews': 'Global news',
    'landingSkillList.tag.realtimeMarket': 'Realtime quotes',
    'landingSkillList.tag.trade': 'Trade',
    'landingSkillList.tag.brandLoyalty': 'Brand loyalty',
    'landingSkillList.tag.productSatisfaction': 'Product satisfaction',
    'landingSkillList.tag.marketTrend': 'Market trend',
    'landingFigma.heroBrand': 'FinTrust Skills Hub',
    'landingFigma.heroLine1': 'A trustworthy ',
    'landingFigma.heroAccent1': 'financial Skills hub',
    'landingFigma.heroLine2': ' · Bringing together ',
    'landingFigma.heroAccent2': 'professional trading',
    'landingFigma.heroAccent3': ' capabilities',
    'landingFigma.pill1': 'Aiming to be the #1 financial skills platform',
    'landingFigma.pill2': 'Curated, stable financial skills',
    'landingFigma.installTitle': 'One-click install FinTrust Skills Hub',
    'landingFigma.installDesc': 'Copy the command below and send it to any AI — it will guide you through Skill installation.',
    'landingFigma.installGuide': 'Installation guide',
    'landingFigma.getApiKey': 'Get API Key',
    'installGuide.heroTitle': 'FinTrust Skill installation guide',
    'installGuide.heroLead':
      'Two steps: 1. Install an AI agent 2. Send the install command to your agent to complete Skill installation.',
    'installGuide.step1Title': 'Step 1: Install an AI agent',
    'installGuide.step1Body':
      'Choose any agent below, open its official site, and complete download, sign-in, and setup until you can chat normally. FinTrust Skills are compatible with the OpenClaw skill ecosystem; channels (desktop / Lark / WeChat, etc.) and configuration vary by product—follow each vendor’s latest docs.',
    'installGuide.tableAgent': 'Agent',
    'installGuide.tableSummary': 'Summary',
    'installGuide.tableUrl': 'Website',
    'installGuide.agentsJson':
      '[{"name":"OpenClaw","desc":"Open-source personal AI assistant with a mature skills and channel ecosystem.","href":"https://www.openclaw.ai/"},{"name":"Hermes","desc":"Self-evolving agent from Nous Research with multi-channel access.","href":"https://github.com/NousResearch/hermes-agent"},{"name":"QClaw","desc":"Tencent local AI assistant; supports WeChat remote control of your PC.","href":"https://qclaw.qq.com/"},{"name":"WorkBuddy","desc":"Tencent all-scenario workplace AI agent desktop.","href":"https://copilot.tencent.com/work/"},{"name":"ArkClaw","desc":"ByteDance cloud agent (BytePlus).","href":"https://www.byteplus.com/en/product/arkclaw"},{"name":"AutoClaw","desc":"Zhipu AI one-click local OpenClaw-style deployment.","href":"https://autoclaws.org/zh/"},{"name":"MaxClaw","desc":"MiniMax cloud AI agent.","href":"https://maxclaw.ai/"}]',
    'installGuide.step2Title': 'Step 2: Install skills (copy command → send to agent)',
    'installGuide.step2Body':
      'Open the target Skill on FinTrust Skills Hub, copy the install command from the detail page (often a Markdown link or a “Read https://…” instruction). Paste it into your agent chat and send; the agent will fetch the manifest and install the Skill. If the client supports one-click sync from a skill marketplace, follow in-product guidance—the core step is still handing the install command to the agent.',
    'installGuide.step2Recommend':
      'Recommended install command (on each skill detail page), for example:',
    'installGuide.step2ReadPrefix':
      'Please read the following link and install FinTrust / FinSkill Hub skills for this session per the document: ',
    'installGuide.step2UrlNote':
      'Use the command shown on each skill detail page; hub-level and per-skill install URLs may differ.',
    'installGuide.step2Verify':
      'After the Skill is installed, paste any example question below to verify.',
    'installGuide.step3Title': 'Step 3: After installation, you can ask your AI assistant:',
    'installGuide.questionGroupsJson':
      '[{"title":"Live quotes","questions":["What is Tencent 00700.HK trading around now? Over the last 5 sessions, is it strong or weak?","For Kweichow Moutai 600519.SH, summarize the last month’s daily range and close strength—plain language, no jargon.","How did the Hang Seng Index move this week? Any day with obvious volume spike?"]},{"title":"Smart trading","questions":["I want to place a limit buy for Tencent 00700—what should we double-check before submitting?","My order hasn’t filled for a while; what should I know before changing price or canceling?","What does a trailing stop roughly mean? Is it for “hold winners, auto-sell on pullback”?"]},{"title":"Advisory","questions":["I want to invest spare cash in Tencent 00700—what should you help me verify first?","If the market drops sharply today, what checks should I run first?","What are this week’s main themes? Which sectors see active flows?"]}]',
    'installGuide.tocTitle': 'On this page',
    'installGuide.tocItemsJson':
      '[{"id":"install-agent","title":"Step 1: Install an AI agent"},{"id":"install-skill","title":"Step 2: Install skills"},{"id":"ask-agent","title":"Step 3: Ask your assistant"}]',
    'landingFigma.copyCmd': 'Copy',
    'landingFigma.noInstallUrl': 'Install URL is not configured.',
    'landingFigma.copyFail': 'Copy failed',
    'landingFigma.aiToolsTitle': 'Works with mainstream AI tools',
    'landingFigma.aiMore': 'More…',
    'landingFigma.capTitle': 'What can FinTrust Skills do?',
    'landingFigma.tab1': 'Market snapshot',
    'landingFigma.tab2': 'Smart strategy trading',
    'landingFigma.tab3': 'Portfolio overview',
    'landingFigma.tab4': 'Stock deep dive',
    'landingFigma.tab5': 'News interpretation',
    'landingFigma.capHint':
      'Supports 13 order types: limit / market / stop-loss / trailing stop / auction / enhanced limit · 5 major markets',
    'landingFigma.capHintStrong': ['13 order types'],
    'landingFigma.capMockName': 'AI Assistant · FinTrust Skills',
    'landingFigma.capUserAvatar': 'You',
    'landingFigma.capAiAvatar': 'AI',
    'landingFigma.mockUserQ': 'What are the notable updates on Tencent recently?',
    'landingFigma.mockAiTitle': 'Tencent 00700.HK · Equity brief',
    'landingFigma.mockAiBody':
      'Q4 revenue up 13% YoY with ongoing buybacks, plus green datacenter and AI strategy signals.',
    'landingFigma.mockTag': 'Bullish',
    'landingFigma.mockSignals': 'Key signals',
    'landingFigma.mockSignalsList':
      '· Q4 revenue +13% YoY, opening gap up 2%\n· Mar 31 buyback ~HK$301M\n· Green-power AIDC partnership\n· VP sees domestic AI competition as a necessary stage',
    'landingFigma.mockEvidence': 'Key evidence',
    'landingFigma.capDraft': 'When did Apple go public, and what is its main business?',
    'landingFigma.capTrialBefore': 'To try FinTrust Skill, please ',
    'landingFigma.capTrialCta': 'click here',
    'landingFigma.capSidebarTitle': 'Generation overview',
    'landingFigma.capSend': 'Send',
    'landingFigma.capReply':
      'Copy the install command above and send it to your agent so it can read skill.md and enable FinTrust Skills Hub finance skills.',
    'landingFigma.capSidebarGroupsJson':
      '[{"k":"Generation progress","values":["95.03%"]}]',
    'landingFigma.skillPanelsJson':
      '[{"title":"Finloop Financial News Skill","sub":"Track global market news quickly","userQ":"What are the notable updates on Tencent recently?","aiTitle":"Tencent 00700.HK · Equity brief","aiBody":"Q4 revenue up 13% YoY with ongoing buybacks, plus green datacenter and AI strategy signals.","tag":"Bullish","signals":"· Q4 revenue +13% YoY, opening gap up 2%\\n· Mar 31 buyback ~HK$301M\\n· Green-power AIDC partnership\\n· VP sees domestic AI competition as a necessary stage","evidence":[{"title":"1. Tencent sets a new starting line with a $10B push","url":"https://news.futunn.com/post/70950818"},{"title":"2. Morning move | Tencent rises over 2% after Q4 revenue grows 13% YoY","url":"https://news.futunn.com/post/70941879"},{"title":"3. Mar 31 buyback roundup | Tencent spends HK$301M","url":"https://news.futunn.com/post/70937739"}]},{"title":"Finloop Realtime Quotes Skill","sub":"Analyze Tencent technical signals","userQ":"What signals are showing in Tencent intraday trading today?","aiTitle":"Tencent 00700.HK · Realtime market snapshot","aiBody":"The stock remains in a choppy uptrend with higher volume than the prior session, showing improved short-term capital attention. Based on moving averages, order-book context, and volume-price structure, waiting for a pullback confirmation is more suitable now.","tag":"Watch","signals":"· Intraday volume expanded with higher active-buying share\\n· Price moved above short-cycle moving averages, improving momentum\\n· HK tech sector strengthened together, supporting sentiment\\n· Near resistance, chasing higher still carries risk","evidence":[{"title":"1. Tencent realtime quotes and order-book moves","url":"https://www.futunn.com/stock/00700-HK"},{"title":"2. Intraday performance of HK tech sector","url":"https://www.futunn.com/stock/hk/sector"},{"title":"3. Technical indicators and intraday volume-price analysis","url":"https://www.futunn.com/quote"}]},{"title":"Fosun Wealth Skill","sub":"Smart automated order placement","userQ":"If Tencent pulls back to support, how should the trade plan be split?","aiTitle":"Tencent 00700.HK · Automated trading plan","aiBody":"Split entry into observation, pilot position, and confirmation: set a price alert first, verify support with a small position, then decide whether to add based on volume and stop-loss conditions.","tag":"Plan","signals":"· Wait for volume-backed stabilization after touching support\\n· Keep the pilot position at 30% of planned size\\n· Trigger stop loss automatically if key price breaks\\n· If price breaks the previous high with volume, raise position in batches","evidence":[{"title":"1. Conditional orders and price alert setup","url":"https://www.futunn.com/support"},{"title":"2. HK stock order type guide","url":"https://www.futunn.com/support/topic2"},{"title":"3. Risk control and position management reference","url":"https://www.futunn.com/learn"}]}]',
    'landingFigma.officialEyebrow': 'Official Skills',
    'landingFigma.officialTitle': 'Official skills for trading-scenario agents',
    'landingFigma.officialLead':
      'Published and maintained by the platform, focused on trading workflows and compatible with mainstream agents.',
    'landingFigma.officialBullets': [
      'Official publishing & maintenance',
      'Trading-scenario capability building',
      'Agent-ready invocation patterns',
      'Clear versioning & iteration',
    ],
    'landingFigma.officialBulletAccents': [
      'publishing',
      'Trading-scenario',
      'Agent-ready',
      'Clear versioning',
    ],
    'landingFigma.officialMockAsk': 'Which Skill capabilities are officially available?',
    'landingFigma.officialMockHead': 'FinTrust Assistant',
    'landingFigma.officialMockTitle': 'Fosun Wealth Skills: Trading quote engine',
    'landingFigma.officialMockSub':
      'Full-market trading capabilities · Natural-language orders · Full-depth market data',
    'landingFigma.officialMetricsJson':
      '[{"value":"3","label":"major trading markets"},{"value":"11","label":"order types"},{"value":"Lv2","label":"realtime quotes"}]',
    'landingFigma.officialRailLabels': ['Trading', 'Quotes', 'News'],
    'landingFigma.ctaOfficial': 'Go to official skills',
    'landingFigma.visualOfficial': 'Dashboard preview (full fidelity in Figma)',
    'landingFigma.communityEyebrow': 'Global Skills',
    'landingFigma.communityTitle': 'Global Skills curated for finance scenarios',
    'landingFigma.communityLead':
      'Selected from skill communities for real finance workflows — understandable, reusable, traceable.',
    'landingFigma.communityBullets': [
      'Curated from diverse skill communities',
      'Finance usability first',
      'Clearer inputs & outputs',
      'Discoverable via FinTrust Skills Hub',
    ],
    'landingFigma.communityBulletAccents': [
      'Curated',
      'Finance usability',
      'Clearer',
      'Discoverable',
    ],
    'landingFigma.commCardName': 'Earnings reader',
    'landingFigma.commCardDesc':
      'Quarterly reports distilled into revenue, segments, cash flow & guidance — fast sanity check.',
    'landingFigma.commTags': 'earnings,fundamentals,call,guidance,themes,+2',
    'landingFigma.commBadge': 'Global',
    'landingFigma.communityCardsJson':
      '[{"initial":"E","name":"Earnings reader","meta":"clawhub · earnings-reader","desc":"Quarterly reports distilled into revenue, segments, cash flow & guidance — fast sanity check.","tags":["earnings","fundamentals","call","guidance","themes","+2"]},{"initial":"P","name":"AI Trading Psychology Coach","meta":"clawhub · trading-psychology","desc":"Focuses on trading behavior and emotion: identifies common cognitive biases, turns P&L reviews into discussable decision chains, and provides review questions on position sizing and discipline.","tags":["behavioral finance","trading psychology","review","risk control","emotion","+2"]},{"initial":"T","name":"Theme Library Analyst","meta":"clawhub · subject-library","desc":"Built for A-share market themes: browse theme lists and heat, break down theme logic, inspect links between themes and stocks, and support ranking plus multi-dimensional theme intelligence.","tags":["A-shares","themes","hot ranking","stock links","theme mining","+2"]}]',
    'landingFigma.ctaCommunity': 'Go to global skills',
    'landingFigma.testimonialsEyebrow': 'Product advantages',
    'landingFigma.testimonialsTitle': 'Real feedback from users and teams',
    'landingFigma.testimonialsLead':
      'From individual investors to developers, FinTrust is helping more users discover, connect to, and use financial Skills more efficiently.',
    'landingFigma.quoteCardsJson':
      '[{"title":"Efficient.","body":"Reading earnings reports used to mean switching back and forth between quote screens, broker pages, and PDFs. Now with official Skills connected to my Agent, I can get live stock prices and earnings highlights directly in conversation — information is more centralized and decisions come faster.","initial":"C","name":"Ms. Chen","role":"Individual investor"},{"title":"Convenient.","body":"Updating a skill used to mean changing configs, tweaking YAML, and repeated integration testing. Now with FinHub, I can pull versioned Skill packages and integrate them quickly, greatly reducing manual configuration and environment pitfalls.","initial":"L","name":"Mr. Li","role":"Quant enthusiast"},{"title":"Stable.","body":"Financial scenarios have higher requirements for stability and auditability. Through community feedback, review information, and the official changelog, we can more clearly judge whether a Skill is reliable and feel more confident using it in production.","initial":"W","name":"Mr. Wang","role":"Independent developer"}]',
    'landingFigma.quoteBadges': [
      'More efficient earnings access',
      'Less config for skill integration',
      'Stronger basis for launch decisions',
    ],
    'landingFigma.appBrandMark': 'W',
    'landingFigma.appTitleBefore': 'Trade globally with ',
    'landingFigma.appTitleAccent': '「Fosun Wealth APP」',
    'landingFigma.appSubBefore': 'Download and open an account to unlock official ',
    'landingFigma.appSubBold': 'global news, quotes & trading capabilities',
    'landingFigma.appSubAfter': '.',
    'landingFigma.appDownload': 'Download now',
    'landingFigma.appContact': 'Contact us',
    'landingFigma.appDownloadHoverTitle': 'Scan to download Fosun Wealth APP',
    'landingFigma.appDownloadIos': 'iOS',
    'landingFigma.appDownloadAndroid': 'Android',
    'landingFigma.appContactHoverTitle': 'Contact us',
    'landingFigma.appContactHkLabel': 'Hong Kong hotline',
    'landingFigma.appContactOtherLabel': 'Other hotline',
    'landingFigma.appBanner': 'Give your Agent professional financial skills and platform capabilities now',
    'landingFigma.appBannerCta': 'Open account',
    'landingFigma.phoneChips': ['HK stocks', 'Options', 'US stocks', 'Funds'],
    'landingFigma.appMarketCardsJson':
      '[{"name":"Hang Seng Index","value":"24683.440","change":"14.20 +10.01%"},{"name":"HSCEI","value":"8933.430","change":"14.20 +10.01%"},{"name":"Hang Seng Tech","value":"5569.440","change":"14.20 +10.01%"}]',
    'landingFigma.footerDesc':
      'A financial AI Skills platform for mainstream Agents, covering official skills, global skills, search, and updates.',
    'landingFigma.risk':
      'Risk note: This tool is for technical assistance only and not investment advice. Past performance does not guarantee future results. You make your own decisions and bear the risks. Third-party AI agents are not provided by us; their outputs may be inaccurate — you assume all risks from using them.',
    'aboutPage.documentTitle': 'About | FinTrust Skills Hub',
    'aboutPage.heroTitle': 'Fosun Wealth App',
    'aboutPage.heroSub': 'Web5, AI, Securities',
    'aboutPage.sectionProducts': 'Product categories',
    'aboutPage.productsTitle': 'Diverse products — invest globally, anytime',
    'aboutPage.cardUS': 'US stocks',
    'aboutPage.cardUSBadge': '24h trading',
    'aboutPage.cardHK': 'HK stocks',
    'aboutPage.cardA': 'A-Share Connect',
    'aboutPage.cardVA': 'Virtual assets',
    'aboutPage.oneAccountTitle': 'One account, invest globally',
    'aboutPage.oneAccountBody':
      'US, HK, A-shares, virtual assets, funds, bonds, structured products, and featured wealth solutions.',
    'aboutPage.cta': 'Learn more in the Fosun Wealth app',
    'aboutPage.ctaHref': 'https://www.fosun.com',
    'aboutPage.carouselPrev': 'Previous',
    'aboutPage.carouselNext': 'Next',
    'aboutPage.sectionLicense': 'Licensing and services',
    'aboutPage.licenseLine1': 'Among the first in Hong Kong to hold a',
    'aboutPage.licenseEm': 'virtual-asset trading service license',
    'aboutPage.licenseLine2': 'as a licensed broker',
    'aboutPage.licenseSub': 'Leading digital-asset allocation for the industry',
    'aboutPage.feature1Title': 'Compliant stablecoins\ndeposits & exchange',
    'aboutPage.feature1Body': 'USDT / USDC / BTC / ETH',
    'aboutPage.feature2Title': 'Physical ETF subscription',
    'aboutPage.feature2Body': 'On-screen trading and physical subscription flows.',
    'aboutPage.feature3Title': '7×24 self-service\ncrypto top-up & withdrawal',
    'aboutPage.feature3Body': 'Multi-chain wallet support: ERC-20, TRC-20, BTC',
    'aboutPage.feature4Title': 'RWA tokenized fund subscription',
    'aboutPage.feature4Body':
      'Cathay tokenized money-market fund series, among the most complete globally.',
    'aboutPage.feature5Title': 'Physical ETF subscription',
    'aboutPage.feature5Body': 'In-exchange trading and in-kind subscription.',
    'aboutPage.feature6Title': 'Fosun Wealth on-platform funds',
    'aboutPage.feature6Body': 'HK’s first to list a full suite of three tokenized money-market funds.',
    'aboutPage.disclaimer': 'This page is for reference only and is not investment advice. Investing involves risk.',
    'aboutPage.sectionAi': 'AI investing',
    'aboutPage.aiTitle': 'AI investing',
    'aboutPage.aiTab1': 'AI assistant',
    'aboutPage.aiTab1Hint': 'Multi-agent answers for markets, research, and information',
    'aboutPage.aiTab2': 'AI advisory',
    'aboutPage.aiTab3': 'AI market insights',
    'aboutPage.aiSlogan1': 'Multi-agent answers to investment questions',
    'aboutPage.aiSlogan2': 'Covering markets, research, and information',
    'hero.cta': 'Get Started',
    'hero.ctaSecondary': 'Browse Skills',
    'hero.searchPlaceholder': 'Search skills ',
    'hero.searchClear': 'Clear search',
    'hero.searchSubmit': 'Search',
    'hero.finhubIntro': 'Paste into your agent — enable platform skills now',
    'hero.subNote': 'Free forever. No credit card required.',
    'hero.checks': [
      '200+ curated financial skills',
      'One-click install to your agent',
      'Trusted by 10K+ traders',
    ],
    'hero.install': 'Install',
    'hero.skills': [
      'Fosun Wealth Trading|AI-powered daily stock picks with 200%+ backtested annual return|4.9|2.1K|12K+|Official',
      'Finloop Financial News|Real-time equity screening across 6000+ stocks|4.8|1.8K|9.8K+|Official',
      'Finloop Live Quotes|Portfolio risk scoring with Monte Carlo simulation|4.7|890|7.2K+|Curated',
    ],
    'trust.stats.0.label': 'Financial Skills',
    'trust.stats.1.label': 'Downloads',
    'trust.stats.2.label': 'Avg Rating',
    'trust.stats.3.label': 'Categories',
    'official.label': 'OFFICIAL SKILLS',
    'official.title': 'Official skills, ',
    'official.titleAccent': 'for mainstream agents',
    'official.desc':
      'Official skills are published and maintained by our team for HK/US quotes, research, and trading-adjacent finance workflows.',
    'official.point2Html':
      'Aligned with the <a href="https://agentskills.io" target="_blank" rel="noreferrer">Agent Skill spec</a>',
    'official.points': [
      'Published and maintained by the platform',
      'Works across mainstream agents',
      'Versioned and update-friendly',
    ],
    'official.cta': 'View official skills',
    'official.badge': 'Official',
    'official.slides': [
      'Market Signal Pack|HK/US quotes, research context, and trading-adjacent workflows.|Official · v1.x|strategies|Official market signal banner',
      'Xingfu|Realtime market access for finance agents.|Official · v1.x|copy-trade|Xingfu skill banner',
      'Risk Briefing|Compact portfolio context for agent workflows.|Official · v1.x|whales|Official risk briefing banner',
    ],
    'community.label': 'GLOBAL SKILLS',
    'community.title': 'Global skills, ',
    'community.titleAccent': 'curated for finance',
    'community.desc':
      'Curated global skills focus on real finance workflows with clear inputs, traceable outputs, and strong complementarity to official packs.',
    'community.points': [
      'Curated for finance workflows',
      'Clearer inputs and outputs',
      'Visible quality signals',
      'Discoverable on FinTrust Skills Hub',
    ],
    'community.cta': 'Browse global skills',
    'community.badge': 'Curated',
    'community.slides': [
      'Sector Rotation Watch|Structured rotation signals and observations.|@community · Curated|strategies|Global sector rotation banner',
      'Options Structure Primer|Readable options structure analysis.|@community · Curated|copy-trade|Global options analysis banner',
      'Macro Calendar Alerts|Event timing for finance workflows.|@community · Curated|whales|Global macro calendar banner',
    ],
    'finhub.installCopy': 'Copy',
    'finhub.installCopied': 'Copied',
    'testimonials.label': 'TESTIMONIALS',
    'testimonials.title': 'What people',
    'testimonials.titleAccent': ' are saying',
    'testimonials.items': [
      'Time saved|Earnings season|Sarah Chen|Retail investor|I am a retail investor, not a data engineer. During earnings I used to chase quotes and filings across broker apps and PDFs. Official skills plug into my agent so I can ask for live prices and 10-Q highlights in one thread—no more juggling three windows.',
      'Faster setup|No YAML nights|Michael Park|Quant hobbyist|I sketch strategies after work; I do not have time to babysit agent configs. I used to lose weekends fixing hand-rolled YAML whenever a skill changed. A single install line from FinTrust Skills Hub now pulls versioned packs from the platform the same day—fewer surprises in my repo.',
      'Trust|Audit-friendly|James Wang|Indie developer|We ship a finance copilot, so customers expect review trails and predictable upgrades. Global skills show signals I can read before I adopt them; official packs ship changelogs we can point to. That is the bar before we promote a skill to production.',
    ],
    'download.title': 'For global trading and wealth management — ',
    'download.titleAccent': 'Star Fortune App',
    'download.desc':
      'AI-powered global one-stop Web5 wealth management platform.',
    'download.disclaimer':
      'Safe and reliable — group companies hold SFC licences 1/2/4/6/9 (Hong Kong).',
    'download.badgeAppStoreAlt': 'Download on the App Store',
    'download.badgeGooglePlayAlt': 'Get it on Google Play',
    'download.badgeAppStoreAria': 'App Store download badge. Not available to open yet.',
    'download.badgeGooglePlayAria': 'Google Play download badge. Not available to open yet.',
    'download.qrAlt': 'App download QR code',
    'download.storeQrRowGroupAria': 'App store download badges and download QR code',
    'download.appPreviewClusterAria': 'App screen preview',
    'download.phonePreviewAlt': 'Star Fortune app interface preview',
    'acknowledgment.title': 'Give your agent ',
    'acknowledgment.titleAccent': 'serious finance skills',
    'acknowledgment.thanksText': 'With gratitude to the ClawHub and OpenClaw projects',
    'footer.tagline':
      'A finance AI skills platform for mainstream agents: official skills, global skills, and discovery and updates on FinTrust Skills Hub.',
    'footer.copyright': 'FinTrust Skills Hub. All rights reserved.',
    'footer.nav': 'Footer navigation',
    'footer.home': 'Home',
    'footer.browseSkills': 'Browse Skills',
    'footer.about': 'About us',
    'preview.skills': [
      'Market Signal Pack|Official finance workflow|Official',
      'Risk Briefing|Official portfolio context|Official',
      'Sector Rotation Watch|Global finance workflow|Curated',
    ],
    'browse.hero.ariaSearchSkills': 'Search skills',
    'browse.hero.titlePrefix': 'All ',
    'browse.hero.titleAccent': 'Skills',
    'browse.hero.sub':
      'Scenario-focused and ready in one click: a vast catalog of finance AI skills to take your agent from generalist to specialist.',
    'browse.search.placeholder': 'Search by name, description, tags, or ID',
    'browse.source.from': 'From',
    'browse.all': 'All',
    'browse.source.official': 'Official',
    'browse.source.community': 'Global',
    'browse.aria.skillSource': 'Skill source',
    'browse.aria.advancedFilters': 'Advanced filters: category and sort',
    'browse.aria.advancedPanel': 'Advanced filters',
    'browse.aria.filterByCategory': 'Filter by category',
    'browse.aria.sortBy': 'Sort order',
    'browse.sort.publishedDesc': 'Newest first',
    'browse.sort.titleAsc': 'Title A–Z',
    'browse.crumbs.lead': 'Filters',
    'browse.crumbs.navAria': 'Current filters',
    'browse.crumbs.category': 'Category',
    'browse.crumbs.sort': 'Sort',
    'browse.crumbs.clearCategory': 'Clear category filter',
    'browse.crumbs.clearSort': 'Reset sort to default',
    'browse.crumbs.sortValueTitleAsc': 'Title A–Z',
    'browse.crumbs.tags': 'Tags',
    'browse.crumbs.clearTag': 'Remove tag filter',
    'browse.hotTags.title': 'Popular tags',
    'browse.aria.hotTag': 'Filter by tag',
    'browse.aria.toggleTheme': 'Switch light or dark theme',
    'browse.section.results': 'Search results',
    'browse.loading': 'Loading…',
    'browse.results.zero': '0 results',
    'browse.results.range': 'Items {start}–{end} of {total}',
    'browse.error.fallback': 'Failed to load',
    'browse.retry': 'Retry',
    'browse.empty.title': 'No matching skills',
    'browse.empty.hint': 'Try a shorter keyword or adjust filters.',
    'browse.clearFilters': 'Clear filters',
    'browse.badge.official': 'Official',
    'browse.badge.community': 'Global',
    'browse.pagination.aria': 'Pagination',
    'browse.pagination.prev': 'Previous',
    'browse.pagination.next': 'Next',
    'browse.pagination.page': 'Page {current} / {total}',
    'browse.footer.socialExternal': 'External link',
    'browse.footer.socialGlobe': 'Globe',
    'browse.category.quant': 'Quant trading',
    'browse.category.equity': 'Equity screening',
    'browse.category.risk': 'Risk analytics',
    'browse.category.market': 'Market analysis',
    'browse.category.report': 'Earnings & filings',
    'browse.category.fund': 'Fund research',
    'browse.modal.close': 'Close',
    'browse.modal.retry': 'Retry',
    'browse.modal.loadFailed': 'Failed to load',
    'browse.modal.sectionDetails': 'Details',
    'browse.modal.sectionInstall': 'Install prompt',
    'browse.modal.installHint': 'Copy the prompt below and send it to your agent to install this skill.',
    'browse.modal.copy': 'Copy',
    'browse.modal.copied': 'Copied',
    'browse.modal.manifestJson': 'Manifest JSON',
    'browse.modal.platformSkill': 'Platform skill',
    'browse.modal.sourcePrefix': 'Source: ',
    'browse.modal.publishedPrefix': 'Published ',
    'browse.detail.backLabel': 'Back',
    'browse.detail.backToBrowse': 'Back to skill catalog',
    'browse.detail.trustTitle': 'Security verified',
    'browse.detail.trustBody':
      'Skills published on this platform have passed our security scanning and testing before release.',
    'browse.detail.asideLabel': 'Trust and installation',
    'browse.detail.sectionSkillMd': 'SKILL.md',
    'browse.detail.skillMdEmpty': 'SKILL.md is not available for this skill yet.',
    'browse.detail.skillMdBodyEmpty': 'No Markdown body after frontmatter.',
    'browse.detail.frontmatterTitle': 'Frontmatter',
    'browse.detail.backToTop': 'Back to top',
    'browse.detail.installLead': 'One-click install — copy and send to your agent.',
    'browse.detail.installLockTitle': 'Install command — sign in required',
    'browse.detail.installLockHint': 'Sign in or register to view and copy the install command',
    'browse.detail.installLockCta': 'Log in now',
    'browse.detail.frontmatterObjectKeys': '{n} keys',
    'browse.detail.frontmatterArrayItems': '{n} items',
    'browse.detail.updatedPrefix': 'Updated ',
    'browse.detail.sectionUsage': 'Usage examples',
    'browse.detail.usageExampleUser': 'Example question',
    'browse.detail.usageExampleAssistant': 'Sample assistant reply',
    'browse.detail.installCmdTitle': 'Install command',
    'browse.detail.installCmdHint':
      'Copy the command below and send it to any AI agent to install in one step—no extra setup.',
    'browse.detail.usageDisclaimer':
      'The content above is compiled from public information and is not investment advice.',
    'browse.detail.usageIntroDefault': 'You can trigger this skill with natural-language instructions.',
    'browse.detail.usageExampleFallback': 'Example {n}',
    'search.results.aria': 'Search results',
    'search.results.loading': 'Searching…',
    'search.results.empty': 'No matching skills',
    'search.results.sourcePrefix': 'From ',
  },
  'zh-CN': {
    'nav.search': '搜索',
    'nav.home': '首页',
    'nav.official': '官方Skills',
    'nav.community': '全球Skills',
    'nav.login': '登录',
    'nav.browseSkills': '浏览技能',
    'nav.signUp': '免费注册',
    'nav.logout': '注销',
    'nav.accountMenu': '账号',
    'nav.apiKey': 'API Key',
    'apiKey.title': 'API Key',
    'apiKey.desc': '使用该密钥对 SkillHub 接口请求进行鉴权。',
    'apiKey.loginHint': '登录后可查看并复制你的 API Key。',
    'apiKey.masked': 'fsk_********',
    'apiKey.close': '关闭',
    'apiKey.loading': '加载中…',
    'apiKey.copy': '复制',
    'apiKey.copied': '已复制',
    'apiKey.copyFail': '复制失败',
    'apiKey.retry': '重试',
    'apiKey.loginToCopy': '登录后复制',
    'apiKey.err.needLogin': '请先登录',
    'apiKey.err.badUin': '登录态异常，请重新登录',
    'apiKey.err.verifyFail': '身份校验失败，请稍后重试',
    'apiKey.err.revoked': '密钥已停用，请联系客服',
    'apiKey.err.internal': '系统繁忙，请稍后重试',
    'nav.openMenu': '打开菜单',
    'nav.closeMenu': '关闭菜单',
    'auth.close': '关闭',
    'auth.title': '您好，欢迎登录',
    'auth.desc': '请使用星财富APP账号登录 FinTrust Skills Hub',
    'auth.phonePlaceholder': '请输入手机号码',
    'auth.areaCodeLabel': '区号',
    'auth.areaCodePlaceholder': '+852',
    'auth.areaCodeSearchPlaceholder': '请输入地区或区号搜索',
    'auth.areaCodeLoading': '加载中…',
    'auth.commonRegions': '常用地区',
    'auth.noAreaCodeResults': '无搜索结果',
    'auth.codePlaceholder': '请输入验证码',
    'auth.resendCountdown': '{n} 秒后可重新获取验证码',
    'auth.getCode': '获取验证码',
    'auth.agreePrefix': '我已阅读并同意',
    'auth.userAgreement': '用户协议',
    'auth.agreeAnd': '与',
    'auth.privacy': '隐私声明',
    'auth.login': '登录',
    'auth.submitting': '提交中…',
    'auth.autoRegister': '新用户登录自动注册',
    'auth.registerHint': '使用短信登录，新手机号将自动完成注册',
    'auth.invalidPhone': '请输入正确的手机号',
    'auth.codeSent': '验证码已发送',
    'auth.sendTooOften': '发送过于频繁，请稍后再试',
    'auth.codeSendFailed': '验证码发送失败',
    'auth.captchaFailed': '滑块验证失败，请重试',
    'auth.networkError': '服务器暂无响应，请稍后再试',
    'auth.agreeRequired': '请先阅读并同意用户协议与隐私声明',
    'auth.phoneRequired': '请输入手机号',
    'auth.getCodeFirst': '请先获取验证码',
    'auth.codeRequired': '请输入验证码',
    'auth.submitSuccess': '登录成功',
    'auth.invalidCode': '验证码错误或失效，请重新输入',
    'hero.title': '值得信赖的金融 Skills 中心',
    'hero.titleAccent': '全面汇聚专业能力',
    'nav.about': '关于我们',
    'route.title.landing': 'FinTrust Skills Hub',
    'route.title.official': 'FinTrust Skills Hub – 官方技能',
    'route.title.community': 'FinTrust Skills Hub – 全球技能',
    'route.title.skillHub': 'FinTrust Skills Hub – 技能目录',
    'route.title.skillDetail': 'FinTrust Skills Hub',
    'route.title.installGuide': 'FinTrust Skills Hub – {hero}',
    'landingOfficialPage.heroTitleMain': '官方 Skills',
    'landingOfficialPage.heroTitleSub': '· 由星财富推出',
    'landingOfficialPage.heroDesc':
      '聚焦金融核心场景，由平台官方发布与维护，帮助 Agent 快速获得专业、可靠、可持续更新的金融能力。',
    'landingOfficialPage.loadFailed': '官方 Skills 加载失败',
    'landingCommunityPage.heroTitleMain': '全球 Skills',
    'landingCommunityPage.heroTitleSub': '· 精选安全稳定的金融技能',
    'landingCommunityPage.heroDesc':
      '从各类 Skill 社区中精选适用于金融场景的能力，覆盖股票、A股、DeFi、监控与分析等方向，帮助 Agent 快速扩展专业边界。',
    'landingCommunityPage.loadFailed': '全球 Skills 加载失败',
    'landingSkillList.title': 'Skills',
    'landingSkillList.filterAria': '按标签筛选',
    'landingSkillList.filterLabel': '按标签筛选',
    'landingSkillList.reset': '重置',
    'landingSkillList.loading': '加载中...',
    'landingSkillList.empty': '暂无更多内容',
    'landingSkillList.badgeOfficial': '官方',
    'landingSkillList.badgeCommunity': '全球',
    'landingSkillList.avatarFallback': '技',
    'landingSkillList.officialPaginationLabel': '官方 Skills 分页',
    'landingSkillList.communityPaginationLabel': '全球 Skills 分页',
    'landingSkillList.tag.aiHotNews': 'AI 热闻',
    'landingSkillList.tag.trading': 'Trading',
    'landingSkillList.tag.globalHotNews': '全球热闻',
    'landingSkillList.tag.realtimeMarket': '实时行情',
    'landingSkillList.tag.trade': '交易',
    'landingSkillList.tag.brandLoyalty': '品牌忠诚',
    'landingSkillList.tag.productSatisfaction': '产品满意度',
    'landingSkillList.tag.marketTrend': '市场趋势',
    'landingFigma.heroBrand': 'FinTrust Skills Hub',
    'landingFigma.heroLine1': '值得信赖的 ',
    'landingFigma.heroAccent1': '金融Skills中心',
    'landingFigma.heroLine2': ' · 全面汇聚 ',
    'landingFigma.heroAccent2': '专业交易',
    'landingFigma.heroAccent3': '能力',
    'landingFigma.pill1': '致力成为金融技能平台 NO.1',
    'landingFigma.pill2': '汇集安全稳定的金融技能',
    'landingFigma.installTitle': '一键安装 FinTrust Skills Hub',
    'landingFigma.installDesc': '复制以下指令发送给任意 AI，它会引导你完成 Skill 安装',
    'landingFigma.installGuide': '查看安装指引',
    'landingFigma.getApiKey': '获取 API Key',
    'installGuide.heroTitle': 'FinTrust Skill 安装指引',
    'installGuide.heroLead': '只需要两步：1. 安装智能体 2. 将安装指令发给智能体完成 Skill 安装。',
    'installGuide.step1Title': '第一步：安装智能体',
    'installGuide.step1Body':
      '请先任选一款下列 AI 智能体，打开对应官网，按厂商文档完成下载、账号登录与环境初始化，直到你能在对话窗口里正常与智能体发消息。FinTrust Skill 与 OpenClaw 系技能生态兼容；不同产品在通道（桌面 / 飞书 / 微信等）与配置上略有差异，以各官网最新说明为准。',
    'installGuide.tableAgent': '智能体',
    'installGuide.tableSummary': '一句话',
    'installGuide.tableUrl': '官网地址',
    'installGuide.agentsJson':
      '[{"name":"OpenClaw","desc":"开源个人 AI 助手，技能与频道生态成熟。","href":"https://www.openclaw.ai/"},{"name":"Hermes","desc":"Nous Research 自进化 Agent，多通道接入。","href":"https://github.com/NousResearch/hermes-agent"},{"name":"QClaw","desc":"腾讯本地 AI 助手，支持微信远程操控电脑。","href":"https://qclaw.qq.com/"},{"name":"WorkBuddy","desc":"腾讯全场景职场 AI 智能体桌面工作台。","href":"https://copilot.tencent.com/work/"},{"name":"ArkClaw","desc":"字节跳动旗下云端 Agent（BytePlus）。","href":"https://www.byteplus.com/en/product/arkclaw"},{"name":"AutoClaw","desc":"智谱 AI 一键本地部署类 OpenClaw 方案。","href":"https://autoclaws.org/zh/"},{"name":"MaxClaw","desc":"MiniMax 云端 AI Agent。","href":"https://maxclaw.ai/"}]',
    'installGuide.step2Title': '第二步：安装技能（复制指令→发给智能体）',
    'installGuide.step2Body':
      '在 FinTrust Skills Hub 打开目标 Skill 详情页，复制页面提供的安装命令（通常为一段 Markdown 链接或 Read https://… 类指令）。切换到已安装好的智能体对话窗口，将命令原样粘贴并发送；智能体会按指引拉取 manifest、下载并完成 Skill 安装。若客户端支持「技能市场」侧一键同步，亦可按产品内引导操作，本质仍为把安装指令交给智能体执行。',
    'installGuide.step2Recommend': '推荐使用安装指令（安装指令在每个技能的详情页），例如：',
    'installGuide.step2ReadPrefix':
      '请读取以下链接，并按文档说明为本会话安装 FinTrust / FinSkill Hub 相关 skill：',
    'installGuide.step2UrlNote': '具体以各 Skill 详情页展示的安装命令为准；平台 Skill 与单个 Skill 的安装 URL 可能不同。',
    'installGuide.step2Verify': 'Skill 安装成功后，可直接粘贴下文示例问题中任意一句进行验证。',
    'installGuide.step3Title': '第三步：安装完成后，你可以这样问 AI 助手：',
    'installGuide.questionGroupsJson':
      '[{"title":"实时报价","questions":["腾讯 00700.HK 现在大概什么价位？最近 5 个交易日算强还是偏弱？","贵州茅台 600519.SH，最近一个月日 K 只要高低区间和收盘强弱，别提术语。","恒生指数最近一周怎么走？有没有明显放量的一天？"]},{"title":"智能交易","questions":["我想限价买入腾讯 00700，下单前你要和我一起核对哪些信息？","挂单半天没成交，想改价或撤单，要注意什么？","追踪止损大概是什么意思？适合「涨了还想拿、跌了想自动卖」吗？"]},{"title":"智能投顾","questions":["我想用闲钱买入腾讯 00700，下单前你要帮我一起核对哪些点？","如果今天大盘突然大跌，我该先做哪些检查？","这周主线大概是什么？哪些板块资金比较活跃？"]}]',
    'installGuide.tocTitle': '页面导航',
    'installGuide.tocItemsJson':
      '[{"id":"install-agent","title":"第一步：安装智能体"},{"id":"install-skill","title":"第二步：安装技能"},{"id":"ask-agent","title":"第三步：安装完成后，你可以这样问"}]',
    'landingFigma.copyCmd': '复制指令',
    'landingFigma.noInstallUrl': '未配置安装地址',
    'landingFigma.copyFail': '复制失败',
    'landingFigma.aiToolsTitle': '支持各大主流 AI 工具',
    'landingFigma.aiMore': '更多…',
    'landingFigma.capTitle': 'FinTrust Skills 能做什么？',
    'landingFigma.tab1': '实时行情速览',
    'landingFigma.tab2': '智能策略交易',
    'landingFigma.tab3': '持仓全景透视',
    'landingFigma.tab4': '个股深度解读',
    'landingFigma.tab5': '新闻资讯解析',
    'landingFigma.capHint':
      '支持 13 种订单类型：限价 / 市价 / 止损止盈 / 追踪止损 / 竞价 / 增强限价等 · 覆盖 5 大市场',
    'landingFigma.capHintStrong': ['13 种订单类型'],
    'landingFigma.capMockName': 'AI Assistant · FinTrust Skills',
    'landingFigma.capUserAvatar': 'You',
    'landingFigma.capAiAvatar': 'AI',
    'landingFigma.mockUserQ': '腾讯最近有什么值得关注的动态?',
    'landingFigma.mockAiTitle': '腾讯控股 00700.HK · 个股解读',
    'landingFigma.mockAiBody':
      'Q4 营收同比增 13% 叠加持续回购，再加上 AIDC 绿电数据中心落地与 AI 战略空间，多重利好信号共振。',
    'landingFigma.mockTag': '看多',
    'landingFigma.mockSignals': '关键信号',
    'landingFigma.mockSignalsList':
      '· Q4 营收同比增 13%，早盘带动股价涨超 2%\n· 3 月 31 日回购耗资 3.01 亿港元\n· 携手落地全球首个 100% 绿电直供 AIDC 数据中心\n· 副总裁：国产 AI 竞争“百舸大战”是必经阶段',
    'landingFigma.mockEvidence': '关键依据',
    'landingFigma.capDraft': '苹果公司是什么时候上市的？主营业务是什么？',
    'landingFigma.capTrialBefore': '试用 FinTrust Skill，请 ',
    'landingFigma.capTrialCta': '点击这里',
    'landingFigma.capSidebarTitle': '生成概览',
    'landingFigma.capSend': '发送',
    'landingFigma.capReply':
      '可复制上方安装指令发送给小龙虾，让它读取 skill.md 并启用 FinTrust Skills Hub 金融技能。',
    'landingFigma.capSidebarGroupsJson':
      '[{"k":"生成进度","values":["95.03%"]}]',
    'landingFigma.skillPanelsJson':
      '[{"title":"星路金融资讯 Skill","sub":"快速查全球热点新闻","userQ":"腾讯最近有什么值得关注的动态?","aiTitle":"腾讯控股 00700.HK · 个股解读","aiBody":"Q4 营收同比增 13% 叠加持续回购，再加上 AIDC 绿电数据中心落地与 AI 战略空间，多重利好信号共振。","tag":"看多","signals":"· Q4 营收同比增 13%，早盘带动股价涨超 2%\\n· 3 月 31 日回购耗资 3.01 亿港元\\n· 携手落地全球首个 100% 绿电直供 AIDC 数据中心\\n· 副总裁：国产 AI 竞争“百舸大战”是必经阶段","evidence":[{"title":"1. \\"100亿美元\\"，是腾讯的新起跑线","url":"https://news.futunn.com/post/70950818"},{"title":"2. 早盘异动｜腾讯控股涨超 2%，第四季营收同比增 13%","url":"https://news.futunn.com/post/70941879"},{"title":"3. 3月31日回购集合｜腾讯控股耗资3.01亿港元","url":"https://news.futunn.com/post/70937739"}]},{"title":"星路实时行情 Skill","sub":"分析腾讯控股技术面","userQ":"腾讯控股今天盘中走势有什么信号?","aiTitle":"腾讯控股 00700.HK · 实时行情速览","aiBody":"股价维持震荡上行，成交量较前一交易时段放大，短线资金关注度提升。结合均线、盘口和量价结构，当前更适合等待回踩确认。","tag":"观察","signals":"· 分时成交量放大，主动买盘占比提升\\n· 价格站上短周期均线，短线动能改善\\n· 港股科技板块同步走强，情绪有支撑\\n· 临近压力位，追高风险仍需控制","evidence":[{"title":"1. 腾讯控股实时行情与盘口异动","url":"https://www.futunn.com/stock/00700-HK"},{"title":"2. 港股科技板块盘中表现","url":"https://www.futunn.com/stock/hk/sector"},{"title":"3. 技术指标与分时量价分析","url":"https://www.futunn.com/quote"}]},{"title":"星财富 Skill","sub":"智能自动化下单","userQ":"如果腾讯回踩支撑位，如何拆分交易计划?","aiTitle":"腾讯控股 00700.HK · 自动化交易计划","aiBody":"可将入场拆成观察、试仓和确认三步：先设价格提醒，再以小仓位验证支撑有效性，最后根据成交量和止损条件决定是否加仓。","tag":"计划","signals":"· 触达支撑区后等待放量企稳\\n· 试仓比例控制在计划仓位的 30%\\n· 跌破关键价位自动触发止损\\n· 若突破前高并放量，可分批提高仓位","evidence":[{"title":"1. 条件单与价格提醒设置","url":"https://www.futunn.com/support"},{"title":"2. 港股订单类型说明","url":"https://www.futunn.com/support/topic2"},{"title":"3. 风控与仓位管理参考","url":"https://www.futunn.com/learn"}]}]',
    'landingFigma.officialEyebrow': '官方 Skills',
    'landingFigma.officialTitle': '官方技能，面向交易场景Agent',
    'landingFigma.officialLead':
      '由平台官方发布与维护，围绕港美股行情、研究、交易与投后分析等核心场景，构建安全、可靠、持续演进的金融技能体系。',
    'landingFigma.officialBullets': [
      '平台官方发布与维护',
      '聚焦交易场景能力构建',
      '兼容主流 Agent 调用规范',
      '版本清晰，支持持续迭代',
    ],
    'landingFigma.officialBulletAccents': ['发布与维护', '能力构建', '兼容主流 Agent', '支持持续迭代'],
    'landingFigma.officialMockAsk': '官方提供了哪些 Skill 技能？',
    'landingFigma.officialMockHead': 'FinTrust Assistant',
    'landingFigma.officialMockTitle': '星财富Skills：交易行情引擎',
    'landingFigma.officialMockSub': '全市场交易能力 · 自然语言下单 · 全级别行情覆盖',
    'landingFigma.officialMetricsJson':
      '[{"value":"3","label":"大交易市场"},{"value":"11","label":"种订单类型"},{"value":"Lv2","label":"实时行情"}]',
    'landingFigma.officialRailLabels': ['交易', '行情', '资讯'],
    'landingFigma.ctaOfficial': '查看全部官方Skills',
    'landingFigma.visualOfficial': '示意：官方控制台（完整视觉见 Figma 节点 1044:1161）',
    'landingFigma.communityEyebrow': '全球 Skills',
    'landingFigma.communityTitle': '全球 Skill，精选金融场景可用能力',
    'landingFigma.communityLead':
      '从各平台 Skill 社区中精选适用于金融场景的 Skill，聚焦真实工作流，强调可理解、可复用、可追踪，并与官方能力形成补充。',
    'landingFigma.communityBullets': [
      '精选自各类 Skill 社区',
      '聚焦金融场景可用性',
      '输入输出更清晰',
      '可由 FinHub 检索获取',
    ],
    'landingFigma.communityBulletAccents': ['精选', '可用性', '更清晰'],
    'landingFigma.commCardName': '财报研读',
    'landingFigma.commCardDesc':
      '财报季专用读本：把季报/年报拆成「营收利润—分部表现—现金流—指引与预期差」几条主线，用中文白话对齐市场和一致预期，便于快速判断业绩成色与后续跟踪清单。',
    'landingFigma.commTags': '财报,基本面,业绩会,预期差,主题挖掘,+2',
    'landingFigma.commBadge': '全球',
    'landingFigma.communityCardsJson':
      '[{"initial":"财","name":"财报研读","meta":"clawhub · earnings-reader","desc":"财报季专用读本：把季报/年报拆成「营收利润—分部表现—现金流—指引与预期差」几条主线，用中文白话对齐市场和一致预期，便于快速判断业绩成色与后续跟踪清单。","tags":["财报","基本面","业绩会","预期差","主题挖掘","+2"]},{"initial":"心","name":"AI 交易心理教练","meta":"clawhub · trading-psychology","desc":"聚焦交易行为与情绪：识别典型认知偏差（追涨杀跌、锚定、过度自信等），把盈亏回放成可讨论的「决策链条」，并给出仓位与纪律层面的复盘提问。","tags":["行为金融","交易心理","复盘","风控","情绪","+2"]},{"initial":"题","name":"题材库分析师","meta":"clawhub · subject-library","desc":"面向 A 股「题材」场景：浏览题材列表与热度，拆解题材逻辑，查看题材与个股的关联强度，并支持题材排行与多维市场题材情报。","tags":["A股","题材","热点排行","个股关联","主题挖掘","+2"]}]',
    'landingFigma.ctaCommunity': '查看全部全球Skills',
    'landingFigma.testimonialsEyebrow': '产品优势',
    'landingFigma.testimonialsTitle': '来自用户与团队的真实反馈',
    'landingFigma.testimonialsLead':
      '从个人投资者到开发者，FinTrust 正在帮助更多用户更高效地发现、接入和使用金融 Skill。',
    'landingFigma.quoteCardsJson':
      '[{"title":"高效。","body":"过去看财报，常常要在行情、券商页面和 PDF 之间来回切换。现在通过官方Skill接入Agent，我可以直接在对话里获取实时股价和财报要点，信息更集中，判断也更快。","initial":"陈","name":"陈女士","role":"个人投资者"},{"title":"便捷。","body":"以前更新一个技能，常常要改配置、调YAML、反复联调。现在通过 FinHub，可以直接拉取版本化 Skill 包并快速接入，大幅减少了手工配置和环境踩坑的时间。","initial":"李","name":"李先生","role":"量化爱好者"},{"title":"稳定。","body":"金融场景对稳定性和可审计性要求更高。通过社区反馈、审核信息和官方 changelog，我们能更清楚地判断一个 Skill 是否可靠，也更放心把它用于正式环境。","initial":"王","name":"王先生","role":"独立开发者"}]',
    'landingFigma.quoteBadges': ['财报获取更高效', '技能接入更省配置', '上线决策更有依据'],
    'landingFigma.appBrandMark': '富',
    'landingFigma.appTitleBefore': '全球炒股理财就用',
    'landingFigma.appTitleAccent': '「星财富APP」',
    'landingFigma.appSubBefore': '下载并完成开户，即可获取官方',
    'landingFigma.appSubBold': '全球资讯、行情、交易能力',
    'landingFigma.appSubAfter': '',
    'landingFigma.appDownload': '立即下载',
    'landingFigma.appContact': '联系我们',
    'landingFigma.appDownloadHoverTitle': '扫码下载 星财富APP',
    'landingFigma.appDownloadIos': 'iOS下载',
    'landingFigma.appDownloadAndroid': 'Android下载',
    'landingFigma.appContactHoverTitle': '联系我们',
    'landingFigma.appContactHkLabel': '香港客服电话',
    'landingFigma.appContactOtherLabel': '其他客服电话',
    'landingFigma.appBanner': '立刻让 Agent 拥有专业金融技能与平台能力',
    'landingFigma.appBannerCta': '点击开户',
    'landingFigma.phoneChips': ['港股', '期权', '美股', '基金'],
    'landingFigma.appMarketCardsJson':
      '[{"name":"恒生指数","value":"24683.440","change":"14.20 +10.01%"},{"name":"国企指数","value":"8933.430","change":"14.20 +10.01%"},{"name":"恒生科技","value":"5569.440","change":"14.20 +10.01%"}]',
    'landingFigma.footerDesc':
      '面向主流 Agent 的金融 AI Skills 平台\n官方技能、全球 Skill，以及 FinTrust Skills Hub 上的检索与更新。',
    'landingFigma.risk':
      '风险提示：本工具仅作为技术辅助与接口对接工具，不构成任何形式的投资建议。历史数据不代表未来表现，用户须自行进行独立判断并承担投资风险。您所使用的 AI Agent 并非由我们提供，其输出结果可能存在不准确或遗漏，任何由您选用的 AI Agent 自主生成的行为所引发的风险及后果，均由您自行承担。',
    'aboutPage.documentTitle': '关于我们 | FinTrust Skills Hub',
    'aboutPage.heroTitle': '星财富 App',
    'aboutPage.heroSub': 'Web5、AI、证券',
    'aboutPage.sectionProducts': '投资品类',
    'aboutPage.productsTitle': '投资品类丰富 随时随地 一站配置',
    'aboutPage.cardUS': '美股',
    'aboutPage.cardUSBadge': '24 小时交易',
    'aboutPage.cardHK': '港股',
    'aboutPage.cardA': 'A 股通',
    'aboutPage.cardVA': '虚拟资产交易',
    'aboutPage.oneAccountTitle': '一个账户 投资全球',
    'aboutPage.oneAccountBody':
      '投资品类包含：美股、港股、A 股、虚拟资产、基金、债券、结构化票据、特色理财等',
    'aboutPage.cta': '去「星财富 App」了解更多',
    'aboutPage.ctaHref': 'https://www.fosun.com',
    'aboutPage.carouselPrev': '上一组',
    'aboutPage.carouselNext': '下一组',
    'aboutPage.sectionLicense': '合规与服务',
    'aboutPage.licenseLine1': '香港首批获得',
    'aboutPage.licenseEm': '虚拟资产交易服务牌照',
    'aboutPage.licenseLine2': '的券商之一',
    'aboutPage.licenseSub': '提供行业领先的数字资产配置方案',
    'aboutPage.feature1Title': '合规稳定币\n入金与兑换',
    'aboutPage.feature1Body': '支持 USDT / USDC / BTC / ETH',
    'aboutPage.feature2Title': '实物 ETF 认购',
    'aboutPage.feature2Body': '支持场内交易与实物申购等流程体验。',
    'aboutPage.feature3Title': '多链钱包\n7×24 小时自助充提',
    'aboutPage.feature3Body': '支持 ERC-20、TRC-20、BTC 等主流链上资产',
    'aboutPage.feature4Title': 'RWA 代币化基金认购',
    'aboutPage.feature4Body': '已上架多支代币化货币基金系列，覆盖多币种与多策略。',
    'aboutPage.feature5Title': '实物申购',
    'aboutPage.feature5Body': '场内交易与实物申购一体化流程。',
    'aboutPage.feature6Title': '复星财富平台化运营',
    'aboutPage.feature6Body': '同步上架多只代币化货币基金，把握数字资产配置先机。',
    'aboutPage.disclaimer': '本页内容仅供参考，不构成任何投资建议。投资有风险，入市须谨慎。',
    'aboutPage.sectionAi': 'AI 智能投资',
    'aboutPage.aiTitle': 'AI 智能投资',
    'aboutPage.aiTab1': 'AI 助手',
    'aboutPage.aiTab1Hint': '多智能体解答，覆盖市场、研报与资讯',
    'aboutPage.aiTab2': 'AI 投顾',
    'aboutPage.aiTab3': 'AI 热点资讯',
    'aboutPage.aiSlogan1': '多智能体解答投资问题',
    'aboutPage.aiSlogan2': '覆盖市场、研报、资讯',
    'hero.cta': '立即开始',
    'hero.ctaSecondary': '浏览技能',
    'hero.searchPlaceholder': '搜索技能',
    'hero.searchClear': '清除搜索',
    'hero.searchSubmit': '搜索',
    'hero.finhubIntro': '复制给 Agent，立即启用平台技能',
    'hero.subNote': '永久免费，无需信用卡。',
    'hero.checks': [
      '200+ 精选金融技能',
      '一键安装到你的 Agent',
      '10K+ 交易员信赖之选',
    ],
    'hero.install': '安装',
    'hero.skills': [
      '星财富交易|AI驱动的每日选股，回测年化收益超200%|4.9|2.1K|1.2万+|官方',
      '星路财经资讯|覆盖6000+只股票的实时筛选|4.8|1.8K|9.8千+|官方',
      '星路实时行情|基于蒙特卡洛模拟的投资组合风险评估|4.7|890|7.2千+|精选',
    ],
    'trust.stats.0.label': '金融技能',
    'trust.stats.1.label': '总下载量',
    'trust.stats.2.label': '平均评分',
    'trust.stats.3.label': '技能分类',
    'official.label': '官方技能',
    'official.title': '官方技能，',
    'official.titleAccent': '面向所有主流 Agent',
    'official.desc':
      '官方技能由平台发布与维护，围绕港美股行情、研究与交易相关能力构建。',
    'official.point2Html':
      '遵循 <a href="https://agentskills.io" target="_blank" rel="noreferrer">Agent Skill 规范</a>',
    'official.points': [
      '平台官方发布与维护',
      '适用于主流 Agent',
      '版本清晰，可持续更新',
    ],
    'official.cta': '查看官方技能',
    'official.badge': '官方',
    'official.slides': [
      '市场信号包|覆盖港美股行情、研究与交易相关工作流。|官方 · v1.x|strategies|官方市场信号 banner',
      '星财富|面向金融 Agent 的实时市场接入能力。|官方 · v1.x|copy-trade|星财富技能 banner',
      '风险简报|为 Agent 提供紧凑的组合风险上下文。|官方 · v1.x|whales|官方风险简报 banner',
    ],
    'community.label': '全球技能',
    'community.title': '全球 Skill，',
    'community.titleAccent': '为金融场景而选',
    'community.desc':
      '精选全球 Skill 聚焦真实金融工作流，强调可理解、可复现、可追踪，并与官方能力形成补充。',
    'community.points': [
      '为金融场景精选',
      '输入输出更清晰',
      '质量信号可见',
      '可通过 FinTrust Skills Hub 检索获取',
    ],
    'community.cta': '浏览全球技能',
    'community.badge': '精选',
    'community.slides': [
      '板块轮动观察|轮动线索与结构化观察。|@community · 精选|strategies|全球板块轮动 banner',
      '期权结构解读|面向交易者的结构化选项解析。|@community · 精选|copy-trade|全球期权结构 banner',
      '宏观日历提醒|重要事件与时点提示。|@community · 精选|whales|全球宏观日历 banner',
    ],
    'finhub.installCopy': '复制',
    'finhub.installCopied': '已复制',
    'testimonials.label': '真实体验',
    'testimonials.title': '来自用户与',
    'testimonials.titleAccent': '团队的反馈',
    'testimonials.items': [
      '省时|财报季少折腾|陈女士|个人投资者|我是散户，不是数据工程师。财报季以前在行情、券商和 PDF 之间来回抄数字。现在官方 Skill 装进 Agent，我能在一个对话里问实时报价和财报要点，不用三开窗口。',
      '更快|少熬配置夜|李先生|量化爱好者|下班后才摸策略，没空给 Agent 守配置。以前技能一更新就要手改一堆 YAML。在 FinTrust Skills Hub 一条命令即可从平台拉取版本化技能包，当天接上，少在仓库里踩坑。',
      '稳|可审计地上线|王先生|独立开发者|我们做金融向 Copilot，用户要看得到升级依据。全球 Skill 能看到口碑与审核信息，官方包有清晰 changelog，我们才敢把某个 Skill 钉进生产环境。',
    ],
    'download.title': '全球炒股理财就用',
    'download.titleAccent': '星财富APP',
    'download.desc': 'AI驱动全球一站式Web5财富管理平台',
    'download.disclaimer': '安全可靠，旗下公司持有香港证监会颁发的1/2/4/6/9号牌照',
    'download.badgeAppStoreAlt': 'App Store 下载',
    'download.badgeGooglePlayAlt': 'Google Play 下载',
    'download.badgeAppStoreAria': 'App Store 下载图标，暂不可点击',
    'download.badgeGooglePlayAria': 'Google Play 下载图标，暂不可点击',
    'download.qrAlt': '应用下载二维码',
    'download.storeQrRowGroupAria': '应用商店下载角标与下载二维码',
    'download.appPreviewClusterAria': '应用界面预览',
    'download.phonePreviewAlt': '星财富 App 界面预览',
    'acknowledgment.title': '让 Agent 拥有',
    'acknowledgment.titleAccent': '专业金融技能与平台能力',
    'acknowledgment.thanksText': '谨此向 ClawHub 与 OpenClaw 项目致谢',
    'footer.tagline':
      '面向主流 Agent 的金融 AI Skills 平台：官方技能、全球 Skill，以及 FinTrust Skills Hub 上的检索与更新。',
    'footer.copyright': 'FinTrust Skills Hub. 保留所有权利。',
    'footer.nav': '页脚导航',
    'footer.home': '首页',
    'footer.browseSkills': '浏览技能',
    'footer.about': '关于我们',
    'preview.skills': [
      '市场信号包|官方金融工作流|官方',
      '风险简报|官方组合上下文|官方',
      '板块轮动观察|全球金融工作流|精选',
    ],
    'browse.hero.ariaSearchSkills': '搜索技能',
    'browse.hero.titlePrefix': '全部',
    'browse.hero.titleAccent': '技能',
    'browse.hero.sub':
      '专精场景，一键就绪：海量金融向 AI 技能，让智能体从通用迈向专家。',
    'browse.search.placeholder': '输入名称、简介、标签或 ID，秒级命中目标技能',
    'browse.source.from': '源自',
    'browse.all': '全部',
    'browse.source.official': '官方',
    'browse.source.community': '全球',
    'browse.aria.skillSource': '技能来源',
    'browse.aria.advancedFilters': '高级筛选：分类与排序',
    'browse.aria.advancedPanel': '高级筛选',
    'browse.aria.filterByCategory': '按分类筛选',
    'browse.aria.sortBy': '排序方式',
    'browse.sort.publishedDesc': '最新发布',
    'browse.sort.titleAsc': '标题 A–Z',
    'browse.crumbs.lead': '筛选',
    'browse.crumbs.navAria': '当前筛选条件',
    'browse.crumbs.category': '分类',
    'browse.crumbs.sort': '排序',
    'browse.crumbs.clearCategory': '清除分类筛选',
    'browse.crumbs.clearSort': '恢复默认排序',
    'browse.crumbs.sortValueTitleAsc': '标题 A–Z',
    'browse.crumbs.tags': '标签',
    'browse.crumbs.clearTag': '移除此标签',
    'browse.hotTags.title': '热门标签',
    'browse.aria.hotTag': '按标签筛选',
    'browse.aria.toggleTheme': '切换浅色或深色主题',
    'browse.section.results': '搜索结果',
    'browse.loading': '加载中…',
    'browse.results.zero': '共 0 条结果',
    'browse.results.range': '第 {start}–{end} 条，共 {total} 条',
    'browse.error.fallback': '加载失败',
    'browse.retry': '重试',
    'browse.empty.title': '没有匹配的技能',
    'browse.empty.hint': '试试更短的关键词，或调整筛选条件',
    'browse.clearFilters': '清除筛选',
    'browse.badge.official': '官方',
    'browse.badge.community': '全球',
    'browse.pagination.aria': '分页',
    'browse.pagination.prev': '上一页',
    'browse.pagination.next': '下一页',
    'browse.pagination.page': '第 {current} / {total} 页',
    'browse.footer.socialExternal': '外部链接',
    'browse.footer.socialGlobe': '网站',
    'browse.category.quant': '量化交易',
    'browse.category.equity': '智能选股',
    'browse.category.risk': '风控分析',
    'browse.category.market': '行情分析',
    'browse.category.report': '财报解读',
    'browse.category.fund': '基金评测',
    'browse.modal.close': '关闭',
    'browse.modal.retry': '重试',
    'browse.modal.loadFailed': '加载失败',
    'browse.modal.sectionDetails': '详细说明',
    'browse.modal.sectionInstall': '安装提示词',
    'browse.modal.installHint': '复制以下提示词发送给您的 Agent，即可自动安装此 Skill',
    'browse.modal.copy': '复制',
    'browse.modal.copied': '已复制',
    'browse.modal.manifestJson': 'Manifest JSON',
    'browse.modal.platformSkill': '平台 Skill',
    'browse.modal.sourcePrefix': '来源：',
    'browse.modal.publishedPrefix': '发布于 ',
    'browse.detail.backLabel': '返回',
    'browse.detail.backToBrowse': '返回技能目录',
    'browse.detail.trustTitle': '安全可信',
    'browse.detail.trustBody': '本平台上架的 Skill 在发布前均已通过平台安全扫描与测试。',
    'browse.detail.asideLabel': '安全与安装',
    'browse.detail.sectionSkillMd': 'SKILL.md',
    'browse.detail.skillMdEmpty': '该技能暂无 SKILL.md 文档。',
    'browse.detail.skillMdBodyEmpty': 'Frontmatter 之后暂无 Markdown 正文。',
    'browse.detail.frontmatterTitle': '元数据（Frontmatter）',
    'browse.detail.backToTop': '回到顶部',
    'browse.detail.installLead': '一键安装，复制发送给 Agent',
    'browse.detail.installLockTitle': '安装指令，需先登录',
    'browse.detail.installLockHint': '登录或注册后可查看并复制安装指令',
    'browse.detail.installLockCta': '立即登录',
    'browse.detail.frontmatterObjectKeys': '{n} 个字段',
    'browse.detail.frontmatterArrayItems': '{n} 项',
    'browse.detail.updatedPrefix': '更新于 ',
    'browse.detail.sectionUsage': '使用示例',
    'browse.detail.usageExampleUser': '示例问题',
    'browse.detail.usageExampleAssistant': 'AI 回答示例',
    'browse.detail.installCmdTitle': '安装命令',
    'browse.detail.installCmdHint': '复制命令，发给任意 AI Agent，一键完成安装，无需额外配置',
    'browse.detail.usageDisclaimer': '以上内容基于公开信息整理，不构成投资建议',
    'browse.detail.usageIntroDefault': '您可以使用自然语言指令触发 skill。',
    'browse.detail.usageExampleFallback': '示例 {n}',
    'search.results.aria': '搜索结果',
    'search.results.loading': '搜索中...',
    'search.results.empty': '暂无相关结果',
    'search.results.sourcePrefix': '源自 ',
  },
  'zh-TW': {
    'nav.search': '搜尋',
    'nav.home': '首頁',
    'nav.official': '官方Skills',
    'nav.community': '全球Skills',
    'nav.login': '登錄',
    'nav.browseSkills': '瀏覽技能',
    'nav.signUp': '免費註冊',
    'nav.logout': '登出',
    'nav.accountMenu': '帳號',
    'nav.apiKey': 'API Key',
    'apiKey.title': 'API Key',
    'apiKey.desc': '使用該密鑰對 SkillHub 介面請求進行鑑權。',
    'apiKey.loginHint': '登錄後可查看並複製你的 API Key。',
    'apiKey.masked': 'fsk_********',
    'apiKey.close': '關閉',
    'apiKey.loading': '載入中…',
    'apiKey.copy': '複製',
    'apiKey.copied': '已複製',
    'apiKey.copyFail': '複製失敗',
    'apiKey.retry': '重試',
    'apiKey.loginToCopy': '登錄後複製',
    'apiKey.err.needLogin': '請先登錄',
    'apiKey.err.badUin': '登錄態異常，請重新登錄',
    'apiKey.err.verifyFail': '身份校驗失敗，請稍後重試',
    'apiKey.err.revoked': '密鑰已停用，請聯絡客服',
    'apiKey.err.internal': '系統繁忙，請稍後重試',
    'nav.openMenu': '開啟選單',
    'nav.closeMenu': '關閉選單',
    'auth.close': '關閉',
    'auth.title': '您好，歡迎登錄',
    'auth.desc': '請使用星財富APP帳號登錄 FinTrust Skills Hub',
    'auth.phonePlaceholder': '請輸入手機號碼',
    'auth.areaCodeLabel': '區號',
    'auth.areaCodePlaceholder': '+852',
    'auth.areaCodeSearchPlaceholder': '請輸入地區或區號搜尋',
    'auth.areaCodeLoading': '載入中…',
    'auth.commonRegions': '常用地區',
    'auth.noAreaCodeResults': '無搜尋結果',
    'auth.codePlaceholder': '請輸入驗證碼',
    'auth.resendCountdown': '{n} 秒後可重新獲取驗證碼',
    'auth.getCode': '獲取驗證碼',
    'auth.agreePrefix': '我已閱讀並同意',
    'auth.userAgreement': '用戶協議',
    'auth.agreeAnd': '與',
    'auth.privacy': '隱私聲明',
    'auth.login': '登錄',
    'auth.submitting': '提交中…',
    'auth.autoRegister': '新用戶登錄自動註冊',
    'auth.registerHint': '使用短訊登錄，新手機號將自動完成註冊',
    'auth.invalidPhone': '請輸入正確的手機號碼',
    'auth.codeSent': '驗證碼已發送',
    'auth.sendTooOften': '發送過於頻繁，請稍後再試',
    'auth.codeSendFailed': '驗證碼發送失敗',
    'auth.captchaFailed': '滑塊驗證失敗，請重試',
    'auth.networkError': '服務器暫無響應，請稍後再試',
    'auth.agreeRequired': '請先閱讀並同意用戶協議與隱私聲明',
    'auth.phoneRequired': '請輸入手機號',
    'auth.getCodeFirst': '請先獲取驗證碼',
    'auth.codeRequired': '請輸入驗證碼',
    'auth.submitSuccess': '登錄成功',
    'auth.invalidCode': '驗證碼錯誤或失效，請重新輸入',
    'hero.title': '值得信賴的金融 Skills 中心',
    'hero.titleAccent': '全面匯聚專業能力',
    'nav.about': '關於我們',
    'route.title.landing': 'FinTrust Skills Hub',
    'route.title.official': 'FinTrust Skills Hub – 官方技能',
    'route.title.community': 'FinTrust Skills Hub – 全球技能',
    'route.title.skillHub': 'FinTrust Skills Hub – 技能目錄',
    'route.title.skillDetail': 'FinTrust Skills Hub',
    'route.title.installGuide': 'FinTrust Skills Hub – {hero}',
    'landingOfficialPage.heroTitleMain': '官方 Skills',
    'landingOfficialPage.heroTitleSub': '· 由星財富推出',
    'landingOfficialPage.heroDesc':
      '聚焦金融核心場景，由平台官方發布與維護，幫助 Agent 快速獲得專業、可靠、可持續更新的金融能力。',
    'landingOfficialPage.loadFailed': '官方 Skills 載入失敗',
    'landingCommunityPage.heroTitleMain': '全球 Skills',
    'landingCommunityPage.heroTitleSub': '· 精選安全穩定的金融技能',
    'landingCommunityPage.heroDesc':
      '從各類 Skill 社群中精選適用於金融場景的能力，覆蓋股票、A股、DeFi、監控與分析等方向，幫助 Agent 快速擴展專業邊界。',
    'landingCommunityPage.loadFailed': '全球 Skills 載入失敗',
    'landingSkillList.title': 'Skills',
    'landingSkillList.filterAria': '依標籤篩選',
    'landingSkillList.filterLabel': '依標籤篩選',
    'landingSkillList.reset': '重置',
    'landingSkillList.loading': '載入中...',
    'landingSkillList.empty': '暫無更多內容',
    'landingSkillList.badgeOfficial': '官方',
    'landingSkillList.badgeCommunity': '全球',
    'landingSkillList.avatarFallback': '技',
    'landingSkillList.officialPaginationLabel': '官方 Skills 分頁',
    'landingSkillList.communityPaginationLabel': '全球 Skills 分頁',
    'landingSkillList.tag.aiHotNews': 'AI 熱聞',
    'landingSkillList.tag.trading': 'Trading',
    'landingSkillList.tag.globalHotNews': '全球熱聞',
    'landingSkillList.tag.realtimeMarket': '即時行情',
    'landingSkillList.tag.trade': '交易',
    'landingSkillList.tag.brandLoyalty': '品牌忠誠',
    'landingSkillList.tag.productSatisfaction': '產品滿意度',
    'landingSkillList.tag.marketTrend': '市場趨勢',
    'landingFigma.heroBrand': 'FinTrust Skills Hub',
    'landingFigma.heroLine1': '值得信賴的 ',
    'landingFigma.heroAccent1': '金融Skills中心',
    'landingFigma.heroLine2': ' · 全面匯聚 ',
    'landingFigma.heroAccent2': '專業交易',
    'landingFigma.heroAccent3': '能力',
    'landingFigma.pill1': '致力成為金融技能平台 NO.1',
    'landingFigma.pill2': '匯集安全穩定的金融技能',
    'landingFigma.installTitle': '一鍵安裝 FinTrust Skills Hub',
    'landingFigma.installDesc': '複製以下指令發送給任意 AI，它會引導你完成 Skill 安裝',
    'landingFigma.installGuide': '查看安裝指引',
    'landingFigma.getApiKey': '獲取 API Key',
    'installGuide.heroTitle': 'FinTrust Skill 安裝指引',
    'installGuide.heroLead': '只需要兩步：1. 安裝智能體 2. 將安裝指令發給智能體完成 Skill 安裝。',
    'installGuide.step1Title': '第一步：安裝智能體',
    'installGuide.step1Body':
      '請先任選一款下列 AI 智能體，打開對應官網，按廠商文檔完成下載、帳號登入與環境初始化，直到你能在對話視窗裡正常與智能體發訊息。FinTrust Skill 與 OpenClaw 系技能生態相容；不同產品在通道（桌面 / 飛書 / 微信等）與設定上略有差異，以各官網最新說明為準。',
    'installGuide.tableAgent': '智能體',
    'installGuide.tableSummary': '一句話',
    'installGuide.tableUrl': '官網地址',
    'installGuide.agentsJson':
      '[{"name":"OpenClaw","desc":"開源個人 AI 助手，技能與頻道生態成熟。","href":"https://www.openclaw.ai/"},{"name":"Hermes","desc":"Nous Research 自進化 Agent，多通道接入。","href":"https://github.com/NousResearch/hermes-agent"},{"name":"QClaw","desc":"騰訊本地 AI 助手，支援微信遠端操控電腦。","href":"https://qclaw.qq.com/"},{"name":"WorkBuddy","desc":"騰訊全場景職場 AI 智能體桌面工作台。","href":"https://copilot.tencent.com/work/"},{"name":"ArkClaw","desc":"字節跳動旗下雲端 Agent（BytePlus）。","href":"https://www.byteplus.com/en/product/arkclaw"},{"name":"AutoClaw","desc":"智譜 AI 一鍵本地部署類 OpenClaw 方案。","href":"https://autoclaws.org/zh/"},{"name":"MaxClaw","desc":"MiniMax 雲端 AI Agent。","href":"https://maxclaw.ai/"}]',
    'installGuide.step2Title': '第二步：安裝技能（複製指令→發給智能體）',
    'installGuide.step2Body':
      '在 FinTrust Skills Hub 打開目標 Skill 詳情頁，複製頁面提供的安裝命令（通常為一段 Markdown 連結或 Read https://… 類指令）。切換到已安裝好的智能體對話視窗，將命令原樣貼上並發送；智能體會按指引拉取 manifest、下載並完成 Skill 安裝。若客戶端支援「技能市場」側一鍵同步，亦可按產品內引導操作，本質仍為把安裝指令交給智能體執行。',
    'installGuide.step2Recommend': '推薦使用安裝指令（安裝指令在每個技能的詳情頁），例如：',
    'installGuide.step2ReadPrefix':
      '請讀取以下連結，並按文檔說明為本會話安裝 FinTrust / FinSkill Hub 相關 skill：',
    'installGuide.step2UrlNote': '具體以各 Skill 詳情頁展示的安裝命令為準；平台 Skill 與單個 Skill 的安裝 URL 可能不同。',
    'installGuide.step2Verify': 'Skill 安裝成功後，可直接貼上下文示例問題中任意一句進行驗證。',
    'installGuide.step3Title': '第三步：安裝完成後，你可以這樣問 AI 助手：',
    'installGuide.questionGroupsJson':
      '[{"title":"即時報價","questions":["騰訊 00700.HK 現在大概什麼價位？最近 5 個交易日算強還是偏弱？","貴州茅台 600519.SH，最近一個月日 K 只要高低區間和收盤強弱，別提術語。","恒生指數最近一週怎麼走？有沒有明顯放量的一天？"]},{"title":"智能交易","questions":["我想限價買入騰訊 00700，下單前你要和我一起核對哪些資訊？","掛單半天沒成交，想改價或撤單，要注意什麼？","追蹤止損大概是什麼意思？適合「漲了還想拿、跌了想自動賣」嗎？"]},{"title":"智能投顧","questions":["我想用閒錢買入騰訊 00700，下單前你要幫我一起核對哪些點？","如果今天大盤突然大跌，我該先做哪些檢查？","這週主線大概是什麼？哪些板塊資金比較活躍？"]}]',
    'installGuide.tocTitle': '頁面導航',
    'installGuide.tocItemsJson':
      '[{"id":"install-agent","title":"第一步：安裝智能體"},{"id":"install-skill","title":"第二步：安裝技能"},{"id":"ask-agent","title":"第三步：安裝完成後，你可以這樣問"}]',
    'landingFigma.copyCmd': '複製指令',
    'landingFigma.noInstallUrl': '未設定安裝位址',
    'landingFigma.copyFail': '複製失敗',
    'landingFigma.aiToolsTitle': '支援各大主流 AI 工具',
    'landingFigma.aiMore': '更多…',
    'landingFigma.capTitle': 'FinTrust Skills 能做什麼？',
    'landingFigma.tab1': '即時行情速覽',
    'landingFigma.tab2': '智能策略交易',
    'landingFigma.tab3': '持倉全景透視',
    'landingFigma.tab4': '個股深度解讀',
    'landingFigma.tab5': '新聞資訊解析',
    'landingFigma.capHint':
      '支援 13 種訂單類型：限價 / 市價 / 止損止盈 / 追蹤止損 / 競價 / 增強限價等 · 覆蓋 5 大市場',
    'landingFigma.capHintStrong': ['13 種訂單類型'],
    'landingFigma.capMockName': 'AI Assistant · FinTrust Skills',
    'landingFigma.capUserAvatar': 'You',
    'landingFigma.capAiAvatar': 'AI',
    'landingFigma.mockUserQ': '騰訊最近有什麼值得關注的動態?',
    'landingFigma.mockAiTitle': '騰訊控股 00700.HK · 個股解讀',
    'landingFigma.mockAiBody':
      'Q4 營收同比增 13% 疊加持續回購，再加上 AIDC 綠電數據中心落地與 AI 戰略空間，多重利好信號共振。',
    'landingFigma.mockTag': '看多',
    'landingFigma.mockSignals': '關鍵信號',
    'landingFigma.mockSignalsList':
      '· Q4 營收同比增 13%，早盤帶動股價漲超 2%\n· 3 月 31 日回購耗資 3.01 億港元\n· 攜手落地全球首個 100% 綠電直供 AIDC 數據中心\n· 副總裁：國產 AI 競爭「百舸大戰」是必經階段',
    'landingFigma.mockEvidence': '關鍵依據',
    'landingFigma.capDraft': '蘋果公司何時上市？主營業務是什麼？',
    'landingFigma.capTrialBefore': '試用 FinTrust Skill，請 ',
    'landingFigma.capTrialCta': '點擊這裡',
    'landingFigma.capSidebarTitle': '生成概覽',
    'landingFigma.capSend': '發送',
    'landingFigma.capReply':
      '可複製上方安裝指令發送給小龍蝦，讓它讀取 skill.md 並啟用 FinTrust Skills Hub 金融技能。',
    'landingFigma.capSidebarGroupsJson':
      '[{"k":"生成進度","values":["95.03%"]}]',
    'landingFigma.skillPanelsJson':
      '[{"title":"星路金融資訊 Skill","sub":"快速查全球熱點新聞","userQ":"騰訊最近有什麼值得關注的動態?","aiTitle":"騰訊控股 00700.HK · 個股解讀","aiBody":"Q4 營收同比增 13% 疊加持續回購，再加上 AIDC 綠電數據中心落地與 AI 戰略空間，多重利好信號共振。","tag":"看多","signals":"· Q4 營收同比增 13%，早盤帶動股價漲超 2%\\n· 3 月 31 日回購耗資 3.01 億港元\\n· 攜手落地全球首個 100% 綠電直供 AIDC 數據中心\\n· 副總裁：國產 AI 競爭「百舸大戰」是必經階段","evidence":[{"title":"1. \\"100億美元\\"，是騰訊的新起跑線","url":"https://news.futunn.com/post/70950818"},{"title":"2. 早盤異動｜騰訊控股漲超 2%，第四季營收同比增 13%","url":"https://news.futunn.com/post/70941879"},{"title":"3. 3月31日回購集合｜騰訊控股耗資3.01億港元","url":"https://news.futunn.com/post/70937739"}]},{"title":"星路即時行情 Skill","sub":"分析騰訊控股技術面","userQ":"騰訊控股今天盤中走勢有什麼信號?","aiTitle":"騰訊控股 00700.HK · 即時行情速覽","aiBody":"股價維持震盪上行，成交量較前一交易時段放大，短線資金關注度提升。結合均線、盤口和量價結構，當前更適合等待回踩確認。","tag":"觀察","signals":"· 分時成交量放大，主動買盤佔比提升\\n· 價格站上短週期均線，短線動能改善\\n· 港股科技板塊同步走強，情緒有支撐\\n· 臨近壓力位，追高風險仍需控制","evidence":[{"title":"1. 騰訊控股即時行情與盤口異動","url":"https://www.futunn.com/stock/00700-HK"},{"title":"2. 港股科技板塊盤中表現","url":"https://www.futunn.com/stock/hk/sector"},{"title":"3. 技術指標與分時量價分析","url":"https://www.futunn.com/quote"}]},{"title":"星財富 Skill","sub":"智能自動化下單","userQ":"如果騰訊回踩支撐位，如何拆分交易計畫?","aiTitle":"騰訊控股 00700.HK · 自動化交易計畫","aiBody":"可將入場拆成觀察、試倉和確認三步：先設價格提醒，再以小倉位驗證支撐有效性，最後根據成交量和止損條件決定是否加倉。","tag":"計畫","signals":"· 觸達支撐區後等待放量企穩\\n· 試倉比例控制在計畫倉位的 30%\\n· 跌破關鍵價位自動觸發止損\\n· 若突破前高並放量，可分批提高倉位","evidence":[{"title":"1. 條件單與價格提醒設定","url":"https://www.futunn.com/support"},{"title":"2. 港股訂單類型說明","url":"https://www.futunn.com/support/topic2"},{"title":"3. 風控與倉位管理參考","url":"https://www.futunn.com/learn"}]}]',
    'landingFigma.officialEyebrow': '官方 Skills',
    'landingFigma.officialTitle': '官方技能，面向交易場景Agent',
    'landingFigma.officialLead':
      '平台官方發布與維護，聚焦交易場景能力構建，相容主流 Agent 調用規範，版本清晰、可持續迭代。',
    'landingFigma.officialBullets': [
      '平台官方發布與維護',
      '聚焦交易場景能力構建',
      '相容主流 Agent 調用規範',
      '版本清晰，支援持續迭代',
    ],
    'landingFigma.officialBulletAccents': ['發布與維護', '能力構建', '相容主流 Agent', '支援持續迭代'],
    'landingFigma.officialMockAsk': '官方提供了哪些 Skill 技能？',
    'landingFigma.officialMockHead': 'FinTrust Assistant',
    'landingFigma.officialMockTitle': '星財富Skills：交易行情引擎',
    'landingFigma.officialMockSub': '全市場交易能力 · 自然語言下單 · 全級別行情覆蓋',
    'landingFigma.officialMetricsJson':
      '[{"value":"3","label":"大交易市場"},{"value":"11","label":"種訂單類型"},{"value":"Lv2","label":"即時行情"}]',
    'landingFigma.officialRailLabels': ['交易', '行情', '資訊'],
    'landingFigma.ctaOfficial': '查看全部官方Skills',
    'landingFigma.visualOfficial': '示意：官方控制台（完整視覺見 Figma 節點 1044:1161）',
    'landingFigma.communityEyebrow': '全球 Skills',
    'landingFigma.communityTitle': '全球 Skill，精選金融場景可用能力',
    'landingFigma.communityLead':
      '從各平台 Skill 社群中精選適用於金融場景的 Skill，聚焦真實工作流，強調可理解、可複用、可追蹤，並與官方能力形成補充。',
    'landingFigma.communityBullets': [
      '精選自各類 Skill 社群',
      '聚焦金融場景可用性',
      '輸入輸出更清晰',
      '可由 FinHub 檢索取得',
    ],
    'landingFigma.communityBulletAccents': ['精選', '可用性', '更清晰'],
    'landingFigma.commCardName': '財報研讀',
    'landingFigma.commCardDesc':
      '財報季專用讀本：把季報/年報拆成「營收利潤—分部表現—現金流—指引與預期差」幾條主線，用中文白話對齊市場和一致預期，便於快速判斷業績成色與後續跟蹤清單。',
    'landingFigma.commTags': '財報,基本面,業績會,預期差,主題挖掘,+2',
    'landingFigma.commBadge': '全球',
    'landingFigma.communityCardsJson':
      '[{"initial":"財","name":"財報研讀","meta":"clawhub · earnings-reader","desc":"財報季專用讀本：把季報/年報拆成「營收利潤—分部表現—現金流—指引與預期差」幾條主線，用中文白話對齊市場和一致預期，便於快速判斷業績成色與後續跟蹤清單。","tags":["財報","基本面","業績會","預期差","主題挖掘","+2"]},{"initial":"心","name":"AI 交易心理教練","meta":"clawhub · trading-psychology","desc":"聚焦交易行為與情緒：識別典型認知偏差（追漲殺跌、錨定、過度自信等），把盈虧回放成可討論的「決策鏈條」，並給出倉位與紀律層面的複盤提問。","tags":["行為金融","交易心理","複盤","風控","情緒","+2"]},{"initial":"題","name":"題材庫分析師","meta":"clawhub · subject-library","desc":"面向 A 股「題材」場景：瀏覽題材列表與熱度，拆解題材邏輯，查看題材與個股的關聯強度，並支援題材排行與多維市場題材情報。","tags":["A股","題材","熱點排行","個股關聯","主題挖掘","+2"]}]',
    'landingFigma.ctaCommunity': '查看全部全球Skills',
    'landingFigma.testimonialsEyebrow': '產品優勢',
    'landingFigma.testimonialsTitle': '來自用戶與團隊的真實反饋',
    'landingFigma.testimonialsLead':
      '從個人投資者到開發者，FinTrust 正在幫助更多用戶更高效地發現、接入和使用金融 Skill。',
    'landingFigma.quoteCardsJson':
      '[{"title":"高效。","body":"過去看財報，常常要在行情、券商頁面和 PDF 之間來回切換。現在通過官方Skill接入Agent，我可以直接在對話裡獲取即時股價和財報要點，資訊更集中，判斷也更快。","initial":"陳","name":"陳女士","role":"個人投資者"},{"title":"便捷。","body":"以前更新一個技能，常常要改配置、調YAML、反覆聯調。現在通過 FinHub，可以直接拉取版本化 Skill 包並快速接入，大幅減少了手工配置和環境踩坑的時間。","initial":"李","name":"李先生","role":"量化愛好者"},{"title":"穩定。","body":"金融場景對穩定性和可審計性要求更高。通過社區反饋、審核資訊和官方 changelog，我們能更清楚地判斷一個 Skill 是否可靠，也更放心把它用於正式環境。","initial":"王","name":"王先生","role":"獨立開發者"}]',
    'landingFigma.quoteBadges': ['財報獲取更高效', '技能接入更省配置', '上線決策更有依據'],
    'landingFigma.appBrandMark': '富',
    'landingFigma.appTitleBefore': '全球炒股理財就用',
    'landingFigma.appTitleAccent': '「星財富APP」',
    'landingFigma.appSubBefore': '下載並完成開戶，即可獲取官方',
    'landingFigma.appSubBold': '全球資訊、行情、交易能力',
    'landingFigma.appSubAfter': '',
    'landingFigma.appDownload': '立即下載',
    'landingFigma.appContact': '聯繫我們',
    'landingFigma.appDownloadHoverTitle': '掃碼下載 星財富APP',
    'landingFigma.appDownloadIos': 'iOS下載',
    'landingFigma.appDownloadAndroid': 'Android下載',
    'landingFigma.appContactHoverTitle': '聯繫我們',
    'landingFigma.appContactHkLabel': '香港客服電話',
    'landingFigma.appContactOtherLabel': '其他客服電話',
    'landingFigma.appBanner': '立刻讓 Agent 擁有專業金融技能與平台能力',
    'landingFigma.appBannerCta': '點擊開戶',
    'landingFigma.phoneChips': ['港股', '期權', '美股', '基金'],
    'landingFigma.appMarketCardsJson':
      '[{"name":"恆生指數","value":"24683.440","change":"14.20 +10.01%"},{"name":"國企指數","value":"8933.430","change":"14.20 +10.01%"},{"name":"恆生科技","value":"5569.440","change":"14.20 +10.01%"}]',
    'landingFigma.footerDesc':
      '面向主流 Agent 的金融 AI Skills 平台，覆蓋官方技能、全球 Skill，以及 FinTrust Skills Hub 上的檢索與更新。',
    'landingFigma.risk':
      '風險提示：本工具僅作為技術輔助與接口對接工具，不構成任何形式的投資建議。歷史數據不代表未來表現，用戶須自行進行獨立判斷並承擔投資風險。您所使用的 AI Agent 並非由我們提供，其輸出結果可能有不準確或遺漏，任何由您選用的 AI Agent 自主生成的行為所引發的風險及後果，均由您自行承擔。',
    'aboutPage.documentTitle': '關於我們 | FinTrust Skills Hub',
    'aboutPage.heroTitle': '星財富APP',
    'aboutPage.heroSub': 'Web5、AI、證券',
    'aboutPage.sectionProducts': '投資品類',
    'aboutPage.productsTitle': '投資品類豐富 隨時隨地 一站配置',
    'aboutPage.cardUS': '美股',
    'aboutPage.cardUSBadge': '24小時交易',
    'aboutPage.cardHK': '港股',
    'aboutPage.cardA': 'A股通',
    'aboutPage.cardVA': '虛擬資產交易',
    'aboutPage.oneAccountTitle': '一個帳戶 投資全球',
    'aboutPage.oneAccountBody':
      '投資品類包含：美股、港股、A股、虛擬資產、基金、債券、結構化票據產品、特色理財等',
    'aboutPage.cta': '去「星財富App」了解更多',
    'aboutPage.ctaHref': 'https://www.fosun.com',
    'aboutPage.carouselPrev': '上一組',
    'aboutPage.carouselNext': '下一組',
    'aboutPage.sectionLicense': '合規與服務',
    'aboutPage.licenseLine1': '香港首批獲得',
    'aboutPage.licenseEm': '虛擬資產交易服務牌照',
    'aboutPage.licenseLine2': '券商之一',
    'aboutPage.licenseSub': '提供行業領先的數字資產配置方案',
    'aboutPage.feature1Title': '合規穩定幣\n出入金及兌換',
    'aboutPage.feature1Body': '支持 USDT / USDC / BTC / ETH',
    'aboutPage.feature2Title': '實物ETF認購',
    'aboutPage.feature2Body': '支援場內交易與實物申購等體驗流程。',
    'aboutPage.feature3Title': '支持多鏈錢包的\n7x24小時自助充提幣',
    'aboutPage.feature3Body': 'ERC20 / TRC20 / BTC',
    'aboutPage.feature4Title': 'RWA代幣化基金認購',
    'aboutPage.feature4Body':
      '已上架全球最全面的代幣化貨幣基金系列，涵蓋多幣種與多策略。',
    'aboutPage.feature5Title': '實物申購',
    'aboutPage.feature5Body': '場內交易與實物申購一體化流程。',
    'aboutPage.feature6Title': '復星財富平台化營運',
    'aboutPage.feature6Body': '香港首家同時成功上架多隻代幣化貨幣基金的財富管理平台之一。',
    'aboutPage.disclaimer': '本網站內容僅供參考，不構成任何投資建議或保證。投資有風險，入市需謹慎。',
    'aboutPage.sectionAi': 'AI 智能投資',
    'aboutPage.aiTitle': 'AI 智能投資',
    'aboutPage.aiTab1': 'AI助手',
    'aboutPage.aiTab1Hint': '多智能體解答投資問題，覆蓋市場、研報、資訊',
    'aboutPage.aiTab2': 'AI 投顧',
    'aboutPage.aiTab3': 'AI 熱點資訊',
    'aboutPage.aiSlogan1': '多智能體解答投資問題',
    'aboutPage.aiSlogan2': '覆蓋市場、研報、資訊',
    'hero.cta': '立即開始',
    'hero.ctaSecondary': '瀏覽技能',
    'hero.searchPlaceholder': '搜尋技能',
    'hero.searchClear': '清除搜尋',
    'hero.searchSubmit': '搜尋',
    'hero.finhubIntro': '複製給 Agent，立即啟用平台技能',
    'hero.subNote': '永久免費，無需信用卡。',
    'hero.checks': [
      '200+ 精選金融技能',
      '一鍵安裝到你的 Agent',
      '10K+ 交易員信賴之選',
    ],
    'hero.install': '安裝',
    'hero.skills': [
      '星財富交易|AI驅動的每日選股，回測年化收益超200%|4.9|2.1K|1.2萬+|官方',
      '星路財經資訊|覆蓋6000+只股票的即時篩選|4.8|1.8K|9.8千+|官方',
      '星路即時行情|基於蒙特卡洛模擬的投資組合風險評估|4.7|890|7.2千+|精選',
    ],
    'trust.stats.0.label': '金融技能',
    'trust.stats.1.label': '總下載量',
    'trust.stats.2.label': '平均評分',
    'trust.stats.3.label': '技能分類',
    'official.label': '官方技能',
    'official.title': '官方技能，',
    'official.titleAccent': '面向所有主流 Agent',
    'official.desc':
      '官方技能由平台發佈與維護，圍繞港美股行情、研究與交易相關能力構建。',
    'official.point2Html':
      '遵循 <a href="https://agentskills.io" target="_blank" rel="noreferrer">Agent Skill 規範</a>',
    'official.points': [
      '平台官方發佈與維護',
      '適用主流 Agent',
      '版本清晰，可持續更新',
    ],
    'official.cta': '查看官方技能',
    'official.badge': '官方',
    'official.slides': [
      '市場訊號包|涵蓋港美股行情、研究與交易相關工作流。|官方 · v1.x|strategies|官方市場訊號 banner',
      '星財富|面向金融 Agent 的即時市場接入能力。|官方 · v1.x|copy-trade|星財富技能 banner',
      '風險簡報|為 Agent 提供精簡的投組風險脈絡。|官方 · v1.x|whales|官方風險簡報 banner',
    ],
    'community.label': '全球技能',
    'community.title': '全球 Skill，',
    'community.titleAccent': '為金融場景而選',
    'community.desc':
      '精選全球 Skill 聚焦真實金融工作流，強調可理解、可重現、可追蹤，並與官方能力形成互補。',
    'community.points': [
      '為金融場景精選',
      '輸入輸出更清晰',
      '品質訊號可見',
      '可透過 FinTrust Skills Hub 檢索取得',
    ],
    'community.cta': '瀏覽全球技能',
    'community.badge': '精選',
    'community.slides': [
      '板塊輪動觀察|輪動線索與結構化觀察。|@community · 精選|strategies|全球板塊輪動 banner',
      '選擇權結構解讀|面向交易者的結構化選項解析。|@community · 精選|copy-trade|全球選擇權結構 banner',
      '宏觀日曆提醒|重要事件與時點提示。|@community · 精選|whales|全球宏觀日曆 banner',
    ],
    'finhub.installCopy': '複製',
    'finhub.installCopied': '已複製',
    'testimonials.label': '真實體驗',
    'testimonials.title': '來自用戶與',
    'testimonials.titleAccent': '團隊的回饋',
    'testimonials.items': [
      '省時|財報季少折騰|陳女士|個人投資者|我是散戶，不是資料工程師。財報季以前要在行情、券商和 PDF 之間來回抄數字。現在官方 Skill 裝進 Agent，我能在一個對話裡問即時報價與財報重點，不用三開視窗。',
      '更快|少熬設定夜|李先生|量化愛好者|下班後才摸策略，沒空幫 Agent 守設定。以前技能一更新就要手改一堆 YAML。在 FinTrust Skills Hub 一條指令即可從平台拉取版本化技能包，當天接上，少在倉庫裡踩坑。',
      '穩|可審計地上線|王先生|獨立開發者|我們做金融向 Copilot，使用者期待看得到升級依據。全球 Skill 能看口碑與審核資訊，官方包有清楚 changelog，我們才敢把某個 Skill 釘進生產環境。',
    ],
    'download.title': '全球炒股理財就用',
    'download.titleAccent': '星財富APP',
    'download.desc': 'AI驅動全球一站式Web5財富管理平台',
    'download.disclaimer': '安全可靠，旗下公司持有香港證監會頒發的1/2/4/6/9號牌照',
    'download.badgeAppStoreAlt': 'App Store 下載',
    'download.badgeGooglePlayAlt': 'Google Play 下載',
    'download.badgeAppStoreAria': 'App Store 下載圖示，暫不可點擊',
    'download.badgeGooglePlayAria': 'Google Play 下載圖示，暫不可點擊',
    'download.qrAlt': '應用程式下載 QR 碼',
    'download.storeQrRowGroupAria': '應用商店下載角標與下載二維碼',
    'download.appPreviewClusterAria': '應用介面預覽',
    'download.phonePreviewAlt': '星財富 App 介面預覽',
    'acknowledgment.title': '讓 Agent 擁有',
    'acknowledgment.titleAccent': '專業金融技能與平台能力',
    'acknowledgment.thanksText': '謹此向 ClawHub 與 OpenClaw 專案致謝',
    'footer.tagline':
      '面向主流 Agent 的金融 AI Skills 平台：官方技能、全球 Skill，以及 FinTrust Skills Hub 上的檢索與更新。',
    'footer.copyright': 'FinTrust Skills Hub. 保留所有權利。',
    'footer.nav': '頁尾導覽',
    'footer.home': '首頁',
    'footer.browseSkills': '瀏覽技能',
    'footer.about': '關於我們',
    'preview.skills': [
      '市場訊號包|官方金融工作流|官方',
      '風險簡報|官方投組脈絡|官方',
      '板塊輪動觀察|全球金融工作流|精選',
    ],
    'browse.hero.ariaSearchSkills': '搜尋技能',
    'browse.hero.titlePrefix': '全部',
    'browse.hero.titleAccent': '技能',
    'browse.hero.sub':
      '專精場景，一鍵就緒：海量金融向 AI 技能，讓智能體從通用邁向專家。',
    'browse.search.placeholder': '輸入名稱、簡介、標籤或 ID，秒級命中目標技能',
    'browse.source.from': '源自',
    'browse.all': '全部',
    'browse.source.official': '官方',
    'browse.source.community': '全球',
    'browse.aria.skillSource': '技能來源',
    'browse.aria.advancedFilters': '進階篩選：分類與排序',
    'browse.aria.advancedPanel': '進階篩選',
    'browse.aria.filterByCategory': '依分類篩選',
    'browse.aria.sortBy': '排序方式',
    'browse.sort.publishedDesc': '最新發布',
    'browse.sort.titleAsc': '標題 A–Z',
    'browse.crumbs.lead': '篩選',
    'browse.crumbs.navAria': '目前篩選條件',
    'browse.crumbs.category': '分類',
    'browse.crumbs.sort': '排序',
    'browse.crumbs.clearCategory': '清除分類篩選',
    'browse.crumbs.clearSort': '恢復預設排序',
    'browse.crumbs.sortValueTitleAsc': '標題 A–Z',
    'browse.crumbs.tags': '標籤',
    'browse.crumbs.clearTag': '移除此標籤',
    'browse.hotTags.title': '熱門標籤',
    'browse.aria.hotTag': '依標籤篩選',
    'browse.aria.toggleTheme': '切換淺色或深色主題',
    'browse.section.results': '搜尋結果',
    'browse.loading': '載入中…',
    'browse.results.zero': '共 0 筆結果',
    'browse.results.range': '第 {start}–{end} 筆，共 {total} 筆',
    'browse.error.fallback': '載入失敗',
    'browse.retry': '重試',
    'browse.empty.title': '沒有符合的技能',
    'browse.empty.hint': '試試更短的關鍵字，或調整篩選條件',
    'browse.clearFilters': '清除篩選',
    'browse.badge.official': '官方',
    'browse.badge.community': '全球',
    'browse.pagination.aria': '分頁',
    'browse.pagination.prev': '上一頁',
    'browse.pagination.next': '下一頁',
    'browse.pagination.page': '第 {current} / {total} 頁',
    'browse.footer.socialExternal': '外部連結',
    'browse.footer.socialGlobe': '網站',
    'browse.category.quant': '量化交易',
    'browse.category.equity': '智能選股',
    'browse.category.risk': '風控分析',
    'browse.category.market': '行情分析',
    'browse.category.report': '財報解讀',
    'browse.category.fund': '基金評測',
    'browse.modal.close': '關閉',
    'browse.modal.retry': '重試',
    'browse.modal.loadFailed': '載入失敗',
    'browse.modal.sectionDetails': '詳細說明',
    'browse.modal.sectionInstall': '安裝提示詞',
    'browse.modal.installHint': '複製以下提示詞傳送給您的 Agent，即可自動安裝此 Skill',
    'browse.modal.copy': '複製',
    'browse.modal.copied': '已複製',
    'browse.modal.manifestJson': 'Manifest JSON',
    'browse.modal.platformSkill': '平台 Skill',
    'browse.modal.sourcePrefix': '來源：',
    'browse.modal.publishedPrefix': '發布於 ',
    'browse.detail.backLabel': '返回',
    'browse.detail.backToBrowse': '返回技能目錄',
    'browse.detail.trustTitle': '安全可信',
    'browse.detail.trustBody': '本平台上架的 Skill 在發布前均已通過平台安全掃描與測試。',
    'browse.detail.asideLabel': '安全與安裝',
    'browse.detail.sectionSkillMd': 'SKILL.md',
    'browse.detail.skillMdEmpty': '此技能暫無 SKILL.md 文件。',
    'browse.detail.skillMdBodyEmpty': 'Frontmatter 之後暫無 Markdown 正文。',
    'browse.detail.frontmatterTitle': '元數據（Frontmatter）',
    'browse.detail.backToTop': '回到頂部',
    'browse.detail.installLead': '一鍵安裝，複製發送給 Agent',
    'browse.detail.installLockTitle': '安裝指令，需先登入',
    'browse.detail.installLockHint': '登入或註冊後可檢視並複製安裝指令',
    'browse.detail.installLockCta': '立即登入',
    'browse.detail.frontmatterObjectKeys': '{n} 個欄位',
    'browse.detail.frontmatterArrayItems': '{n} 項',
    'browse.detail.updatedPrefix': '更新於 ',
    'browse.detail.sectionUsage': '使用範例',
    'browse.detail.usageExampleUser': '示例問題',
    'browse.detail.usageExampleAssistant': 'AI 回答示例',
    'browse.detail.installCmdTitle': '安裝指令',
    'browse.detail.installCmdHint': '複製指令，傳送給任意 AI Agent，一鍵完成安裝，無需額外設定',
    'browse.detail.usageDisclaimer': '以上內容基於公開資訊整理，不構成投資建議',
    'browse.detail.usageIntroDefault': '您可以使用自然語言指令觸發 skill。',
    'browse.detail.usageExampleFallback': '示例 {n}',
    'search.results.aria': '搜尋結果',
    'search.results.loading': '搜尋中...',
    'search.results.empty': '暫無相關結果',
    'search.results.sourcePrefix': '源自 ',
  },
}
